{
  "A11Y": {
    "TRANSLATABLE_FORM_TAB_ARIA_LABEL": "Vorm taal keuse-oortjies"
  },
  "ACCESS_CONTROL": {
    "WITHOUT_RIGHT_PERMISSIONS": "U het nie voldoende regte om hierdie bladsy te betree nie."
  },
  "ADD_TO_CALENDAR": {
    "TITLE": "Kalender",
    "URL_WITH_EVENT": "{description} \n Sluit aan by die videokonferensie: {url}"
  },
  "ANONYMOUS": "Anoniem",
  "API_SAUCE": {
    "CANCEL_ERROR": "Die bediener versoek is onderbreek.",
    "CLIENT_ERROR": "Oeps, 'n onverwagse fout het voorgekom.",
    "CONNECTION_ERROR": "Die bediener is nie beskikbaar nie.",
    "NETWORK_ERROR": "Netwerkfout, kontroleer u verbinding.",
    "SERVER_ERROR": "Oeps, 'n onverwagse fout het voorgekom.",
    "TIMEOUT_ERROR": "Die bediener het nie betyds gereageer nie."
  },
  "ARTICLE": {
    "NOT_PUBLISHED": "Nie gepubliseer nie",
    "PUBLICATION_ALERT": "Beplan op {date} om {time}."
  },
  "ASSIGNMENT_CARD": {
    "AVATAR_ALT": "Foto van die verantwoordelike",
    "TITLE": "Verantwoordelik"
  },
  "ASSIGNMENT_MODAL": {
    "CHOOSE_ADMIN": "Kies 'n administrateur",
    "TITLE": "Ken die hantering van hierdie bydrae toe"
  },
  "ATTACHMENTS": {
    "ERROR": {
      "DELETE_FAILED": "Ons kon nie hierdie bylaag uitvee nie.",
      "TITLE": "Fout -"
    }
  },
  "ATTENDANCE": {
    "ATTEND": "Ek neem deel",
    "ATTENDING": "Geregistreer"
  },
  "AUTH": {
    "ACCEPT_SPACE_PRIVACY": "Ek aanvaar die <terms>privaatheidsbeleid</terms> van {spaceName}.",
    "ACCEPT_SPACE_TERMS": "Ek aanvaar die <privacy>gebruikvoorwaardes</privacy> van {spaceName}.",
    "ACCEPT_SPACE_TERMS_AND_PRIVACY": "Ek aanvaar <privacy>die privaatheidsbeleid</privacy> en <terms>die gebruiksvoorwaardes</terms> van {spaceName}.",
    "ACCEPT_TERMS_AND_PRIVACY": "Ek aanvaar die {privacy} en die {terms} van Fluicity Engage.",
    "ARIA_AUTHENTICATE_WITH": "Teken in met {provider}",
    "AUTH_LIST_TITLE": "Dienste van derdeparty-verifikasie",
    "BACKGROUND_ALT": "Agtergrondillustrasie",
    "CONTINUE_WITHOUT_SIGNUP": "Aanhou sonder rekening",
    "DELETE_TOAST": "Die derdeparty-verifikasiediens is suksesvol ontkoppel.",
    "DESCRIPTION": "Jou registrasie op Fluicity Engage sal jou in staat stel om deel te neem aan die konsultasies oor {spaceName} en sal jou toegang gee tot die ander konsultasies wat op Fluicity Engage gereël word. Om meer te wete te kom oor die bestuur van jou persoonlike data en om jou regte uit te oefen, raadpleeg ons <b>Privaatheidsbeleid.</b>",
    "EMAIL_PLACEHOLDER": "exemple@email.com",
    "ENTITY_SUBSCRIPTION_FORM": {
      "CONTENT": "Deur by <strong>{spaceName}</strong> aan te sluit, sal jy op hoogte gehou word van die jongste konsultasies en nuus.<br></br><br></br>Jy kan ook help om beter te verstaan of die aktiwiteit verteenwoordigend is van die algemene bevolking deur 'n paar inligting te deel:",
      "TITLE": "Sluit aan by {spaceName}!"
    },
    "ERRORS": {
      "CANNOT_DELETE_WITHOUT_PASSWORD": "Stel 'n wagwoord in om hierdie derdeparty-verifikasiediens te verwyder.",
      "DELETE_AUTH_FAILED": "Ons kon nie hierdie derdeparty-verifikasiediens verwyder nie.",
      "INVALID_EMAIL": "Die formaat van jou e-posadres is verkeerd.",
      "NO_ASSOCIATED_ACCOUNT": "Geen rekening is gekoppel nie.",
      "REQUIRED_CHECKBOX": "U moet hierdie kassie merk.",
      "REQUIRED_EMAIL": "U moet 'n e-posadres verskaf.",
      "REQUIRED_FIRST_NAME": "U moet 'n voornaam invul.",
      "REQUIRED_LAST_NAME": "U moet 'n naam invul.",
      "REQUIRED_PASSWORD": "Jy moet 'n wagwoord invul.",
      "SHORT_PASSWORD": "Die wagwoord moet ten minste {count} karakters lank wees."
    },
    "FACEBOOK_LOAD_ERROR": "Dit lyk of 'n uitbreiding wat op jou blaaier geaktiveer is, ons verhoed om Facebook-verifikasie te gebruik. Deaktiveer asseblief die uitbreiding as jy hierdie funksionaliteit wil gebruik.",
    "FIRST_NAME_PLACEHOLDER": "Voorbeeld: Jean",
    "FORGOT_PASSWORD": "Wagwoord vergeet?",
    "HAS_ACCOUNT": "Reeds 'n rekening?",
    "HAS_SIGNED_IN": "Jy is aangemeld by {spaceName}!",
    "LAST_NAME_PLACEHOLDER": "Voorbeeld: Dupont",
    "LOGIN": "Aanmeld",
    "NAME_PREVIEW": "Ander gebruikers sal jou sien as:",
    "NO_ACCOUNT": "Nog nie 'n rekening nie?",
    "OAUTH_BUTTONS": {
      "CSAM": "Sluit aan met CSAM"
    },
    "PAGE_TITLE": "Teken aan",
    "SIGNUP": "Skep 'n rekening",
    "SIGNUP_EXTRAS": {
      "DESCRIPTION": "Help ons om beter te verstaan of die aktiwiteit van die platform verteenwoordigend is van die globale bevolking. Hierdie inligting sal slegs gebruik word vir doeleindes van verifikasie van die legitimiteit van deelnemers en vir statistieke in verband met deelname.",
      "PAGE_TITLE": "Laaste stap!",
      "WELCOME_TOAST": "Veels geluk, jy het by {spaceName} aangesluit!"
    },
    "UNLINK": "Afmeld",
    "VERIFY_EMAIL": {
      "CONTENT": "Voer die verifikasiekode in wat op {email} ontvang is.",
      "RESEND": "Het u nie 'n e-pos ontvang nie? {link}",
      "RESEND_LINK": "Stuur die kode terug",
      "RESEND_SUCCESS": "'n Nuwe verifikasiekode is aan jou gestuur.",
      "TITLE": "Bevestig jou rekening",
      "VERIFY_ALERT": "Gaan na jou e-pos adres om aan al die konsultasies deel te neem.",
      "VERIFY_SUCCESS": "Jou rekening is suksesvol geverifieer."
    }
  },
  "BACK": "Vorige",
  "BUTTONS": {
    "ACCEPT": "Aanvaar",
    "ACCESS_CONSULTATION": "Gaan na die konsultasie",
    "ACTIONS": "Aksies",
    "ADD": "Voeg by",
    "ADD_ATTACHMENTS": "Voeg lêers/beelde by",
    "ADD_NEW_IDEA": "Bydraes",
    "CANCEL": "Kanselleer",
    "CHANGE_USER": "Verander gebruiker",
    "CLEAR": "Vee uit",
    "CLONE": "Dupliseer",
    "CLOSE": "Sluit",
    "COMMENT": "Kommentaar lewer",
    "CONFIRM": "Bevestig",
    "CONTINUE": "Aanhou",
    "DELETE": "Verwyder",
    "DELETE_VOTERS": "Verwyder die stemmers",
    "DRAG_DROP_ATTACHMENTS": "Sleep en plak lêers/beelde hier of klik",
    "EXPORT": "Uitvoerder",
    "EXPORT_PARTICIPANTS": "Voer deelnemers uit",
    "EXPORT_PROPOSALS": "Voer die bydraes uit",
    "EXPORT_RESULTS": "Voer die resultate uit",
    "EXPORT_VOTERS": "Kiesers uitvoer",
    "FILTER": "Filtreer",
    "IGNORE": "Nie nou nie",
    "IMPORT": "Invoer",
    "IMPORT_VIA_EXCEL": "Importeer 'n Excel-lêer",
    "IMPORT_VIA_FORM": "Vul die aanlyn vorm in",
    "IMPORT_VOTERS": "Stemgeregtigdes invoer",
    "IN_PROGRESS": "Besig om te laai…",
    "JOIN": "Aansluit",
    "LEARN_MORE": "Kom meer te wete",
    "NO": "Nee",
    "OPEN": "Maak oop",
    "OPEN_IN_NEW_TAB": "Maak 'n nuwe oortjie oop",
    "PUBLISH": "Publiseer",
    "READ_MORE": "Sien meer",
    "REJECT_ALL": "Verwerp alles",
    "SAVE": "Stoor",
    "SETTINGS": "Instellings",
    "SKIP": "Slaan oor",
    "TRANSLATE_VIA_AI": "Vertaal deur AI",
    "UPDATE": "Wysiger",
    "UPDATE_PICTURE": "Wysiger",
    "UPLOAD_PICTURE": "Voeg 'n foto by",
    "VERIFY": "Bevestig",
    "VERIFY_EMAIL": "Bevestig my e-posadres",
    "VIEW_ANSWER": "Sien die antwoord",
    "VIEW_IDEAS": "Sien die bydraes",
    "VOTE": {
      "BUDGET": "Ek ondersteun",
      "NOT_SUPPORT": "Ek ondersteun nie",
      "SUPPORT": "Ek ondersteun",
      "TOAST": {
        "CANCEL": "Jou stem is suksesvol verwyder.",
        "SUCCESS": "Jou stem is suksesvol opgeteken."
      },
      "VOTE_AGAINST": "Ek stem teen",
      "VOTE_FOR": "Ek stem vir"
    },
    "WRITE": "Skryf"
  },
  "CHILDREN_COUNT": "{count, plural, =0 {Geen inhoud} one {{count} inhoud} other {{count} inhouds}}",
  "COMMENTS": {
    "AUTHOR": "Skrywer",
    "CREATE": {
      "PRIVACY_WARNING": "Hierdie inhoud is vertroulik. Slegs die outeur en die ontvanger organisasie kan dit besigtig.",
      "SUBMIT": "Stuur"
    },
    "CREATION": {
      "APPEND_COMMENT": {
        "IDEA": "Los 'n publieke opmerking om die verandering van status te verduidelik"
      },
      "ERROR": "U moet die velde korrek invul.",
      "PLACEHOLDER": "Jou kommentaar",
      "SUCCESS_ANOMALY": "Jou antwoord is gestuur.",
      "SUCCESS_DEMAND": "Jou antwoord is gestuur.",
      "SUCCESS_IDEA": "Jou kommentaar is gepubliseer.",
      "VALIDATE": "Bevestig"
    },
    "SHOW": {
      "BE_THE_FIRST_TO_COMMENT_CONSULTATION": "Wees die eerste om kommentaar te lewer!",
      "BE_THE_FIRST_TO_COMMENT_MESSAGING": "Hierdie gebruiker wag sedert {date} op u antwoord.",
      "BE_THE_FIRST_TO_COMMENT_PARTICIPATION": "Wees die eerste om kommentaar te lewer!",
      "CONTRIBUTION_ENDED": "Die konsultasie is voltooi",
      "CONTRIBUTION_ENDED_ON": "Die konsultasie het op {datum} geëindig.",
      "CONTRIBUTION_HAS_NOT_STARTED": "Die konsultasie begin op {date}",
      "COUNT_CONSULTATION": "{count, plural, =0 {Geen kommentaar} one {{count} Kommentaar} other {{count} Kommentaar}}",
      "COUNT_MESSAGING": "{count, plural, =0 {Geen antwoorde} one {{count} Antwoord} other {{count} Antwoorde}}",
      "COUNT_PARTICIPATION": "{count, plural, =0 {Geen kommentaar} one {{count} Kommentaar} other {{count} Kommentaar}}"
    },
    "THREAD": {
      "DELETED_COMMENT": "Hierdie opmerking is uitgevee.",
      "DISPLAY_CONVERSATION": "{count, plural, =0 {Geen antwoorde} one {Sien {count} antwoord} other {Sien {count} antwoorde}}",
      "REPLY": "Antwoord"
    },
    "TITLE": "Kommentaar"
  },
  "CONTRAST_RATIO": {
    "DESCRIPTION": "'N Voldoende kontras verseker 'n aanvaarbare vlak van toeganklikheid vir jou gebruikers. In ooreenstemming met internasionale aanbevelings (WCAG) en die van die Algemene Verwysing vir die verbetering van toeganklikheid (RGAA), beveel ons aan om 'n kleur te kies met 'n kontras van ten minste {ratio}:1 (ooreenstemmend met vlak AA van die WCAG standaard weergawe 2.1).",
    "TEXT": {
      "BAD": "Die kontrasvlak vir hierdie kleur is {value}:1, wat nie voldoen aan die aanbevelings vir toeganklikheid (WCAG vlak AA) nie.",
      "GOOD": "Die kontrasvlak vir hierdie kleur is {value}:1 en voldoen aan die aanbevelings vir toeganklikheid (WCAG vlak AA)."
    }
  },
  "COOKIES_SETTINGS": {
    "SSO_AUTH_MODAL": {
      "CONTENT": "{providerName} sal koekies op u masjien plaas as u hierdie funksionaliteit gebruik."
    },
    "VIDEO_PLACEHOLDER": {
      "ADS_BLOCK": "U het 'n advertensieblokker geaktiveer wat verhoed dat hierdie video vertoon word. Skakel dit asseblief af om voort te gaan.",
      "CTA": "Aanvaar die koekies",
      "VIMEO": "Vimeo wil koekies plaas om die video te vertoon",
      "YOUTUBE": "Youtube wil koekies plaas om die video te wys"
    }
  },
  "DASHBOARD": {
    "BUTTONS": {
      "EXPORT": {
        "CONSULTATION": "Voer die bydraes uit",
        "MESSAGING": "Uitvoerder",
        "PARTICIPATION": "Uitvoerder"
      }
    },
    "COUNTERS": {
      "ASSIGNMENT": "{count, plural, =0 {Geen toewysing} one {{count} Toewysing} other {{count} Toewysings}}",
      "COMMUNICATION": "{count, plural, =0 {Geen nuus} one {{count} Nuus} other {{count} Nuus}}",
      "CONSULTATION": "{count, plural, =0 {Geen konsultasie} one {{count} Konsultasie} other {{count} Konsultasies}}",
      "FOLDER": "{count, plural, =0 {Geen lêer} one {{count} Lêer} other {{count} Lêers}}",
      "FOLDER_CONTENT": "{count, plural, =0 {Geen inhoud} one {{count} Inhoud} other {{count} Inhoud}}",
      "FORM_RESPONSES": "{count, plural, =0 {Geen antwoorde} one {{count} Antwoord} other {{count} Antwoorde}}",
      "INVITATIONS": "{count, plural, =0 {Geen uitnodigings} one {{count} uitnodiging} other {{count} uitnodigings}}",
      "MESSAGING": "{count, plural, =0 {Geen inhoud} one {{count} Inhoud} other {{count} Inhoud}}",
      "NEWSLETTERS": "{count, plural, =0 {Geen nuusbrief} one {{count} nuusbrief} other {{count} nuusbriewe}}",
      "PARTICIPATION": "{count, plural, =0 {Geen bydrae} one {{count} Bydrae} other {{count} Bydraes}}",
      "RANKING": "Bydraer-ranglys",
      "USER": "{count, plural, =0 {Geen gebruiker} one {{count} Gebruiker} other {{count} Gebruikers}}",
      "VOTERS": "{count, plural, =0 {Geen kieser} one {{count} Kieser} other {{count} Kiesers}}"
    },
    "COUNTERS_SELECTED": {
      "COMMUNICATION": "{count, plural, =0 {Geen nuus gekies} one {{count} Nuus gekies} other {{count} Nuus gekies}}",
      "CONSULTATION": "{count, plural, =0 {Geen konsultasie gekies nie} one {{count} Konsultasie gekies} other {{count} Konsultasies gekies}}",
      "FOLDER": "{count, plural, =0 {Geen lêer gekies nie} one {{count} Lêer gekies} other {{count} Lêers gekies}}",
      "FOLDER_CONTENT": "{count, plural, =0 {Geen inhoud gekies} one {{count} Inhoud gekies} other {{count} Inhoud gekies}}",
      "MESSAGING": "{count, plural, =0 {Geen inhoud gekies} one {{count} Inhoud gekies} other {{count} Inhoud gekies}}",
      "PARTICIPATION": "{count, plural, =0 {Geen bydrae gekies nie} one {{count} Bydrae gekies} other {{count} Bydraes gekies}}",
      "VOTERS": "{count, plural, =0 {Geen kieser gekies} one {{count} Kiezer gekies} other {{count} Kiesers gekies}}"
    },
    "EDIT": "Aanpassing",
    "EMPTY_STATE": {
      "ASSIGNMENT": "Hier sal u die inhoud vind wat aan u toegewys is.",
      "COMMUNICATION": "Publiseer jou eerste nuusberig",
      "CONSULTATION": "Publiseer jou eerste konsultasie",
      "FOLDER": "Skep jou eerste lêergids",
      "FOLDER_CONTENT": "U sal hier die inhoud van die lêergids vind.",
      "FORM_RESPONSES": "U sal hier die antwoorde op die vraelys vind.",
      "INVITATIONS": "U sal hier die lys van uitnodigings vind.",
      "MESSAGING": "Hier sal u die boodskappe en afwykings vind",
      "NEWSLETTER": "Skep u eerste nuusbrief",
      "PARTICIPATION": "Hier sal u die bydraes van die konsultasie vind.",
      "SEARCH": {
        "BUTTON": "Herstel filters",
        "DESCRIPTION": "Maak seker dat jy jou soektog reg gespel het of verander die filters.",
        "TITLE": "Geen resultaat"
      },
      "USER": "U sal hier die lys van geregistreerde gebruikers vind.",
      "VOTERS": "U sal hier die stemmers van die konsultasie vind."
    },
    "FILTERS": {
      "ADDRESS_CITY": {
        "LABEL": "Gemeente",
        "PLACEHOLDER": "Filtreer volgens gemeente"
      },
      "BLANK": "Nie verstrek nie",
      "FOLDER": {
        "LABEL": "Lêer",
        "PLACEHOLDER": "Filtreer volgens lêergids"
      },
      "NEWSLETTER_STATUS": {
        "DRAFT": "Konsep",
        "SCHEDULED": "Beplan",
        "SENT": "Verstuur"
      },
      "PROF_CATEGORY": {
        "LABEL": "Sosio-professionele kategorie",
        "PLACEHOLDER": "Filtreer volgens sosio-professionele kategorie"
      },
      "REGISTERED": {
        "LABEL": "Geregistreer",
        "PLACEHOLDER": "Filtreer volgens inskrywing",
        "REGISTERED": "Geregistreer",
        "UNREGISTERED": "Nie ingeskryf nie"
      },
      "ROLES": {
        "ADMINISTRATOR": "Administrateur",
        "AUTHOR": "Skrywer",
        "CITIZEN": "Gebruiker",
        "CONTRIBUTOR": "Bestuurder",
        "LABEL": "Rol",
        "PLACEHOLDER": "Filter volgens rol"
      },
      "SEX": {
        "LABEL": "Geslag",
        "PLACEHOLDER": "Filtreer volgens geslag"
      },
      "STATUS": {
        "ANSWERED": "Nie behou nie",
        "DOING": "Besig met ontleding",
        "DONE": "Gerealiseer",
        "DUPLICATE": "Gegroepeer",
        "IN_PROGRESS": "Besig met voltooiing",
        "LABEL": "Status",
        "MESSAGING": {
          "DOING": "Besig met ontleding",
          "DONE": "Antwoord verskaf",
          "LABEL": "Status",
          "PLACEHOLDER": "Filter volgens status",
          "TODO": "Ingedien"
        },
        "PLACEHOLDER": "Filter volgens status",
        "PLANNED": "Beplanne",
        "REJECTED": "Afgekeur",
        "SELECTED": "Inhouding",
        "TODO": "Ingedien",
        "TO_MODERATE": "Om te modereer",
        "VALIDATED": "Wenner"
      },
      "TAG": {
        "LABEL": "Tema",
        "PLACEHOLDER": "Filter volgens tema"
      },
      "TYPES": {
        "ANOMALY": "Anomalie",
        "ARTICLE": "Artikel",
        "COLLABORATIVE_DECISION": "Oorlegging",
        "DEMAND": "Boodskap",
        "EVENT": "Gebeure",
        "FOLDER": "Lêer",
        "IDEA": "Bydrae",
        "IDEAS_REQUEST": "Oproep vir bydraes",
        "LABEL": "Inhoud tipe",
        "PARTICIPATORY_BUDGET": "Deelnemende begroting",
        "PLACEHOLDER": "Filter volgens tipe",
        "STUDY": "Vraelys",
        "SURVEY": "Vraelys"
      },
      "USER_TYPE": {
        "DESCRIPTION": "Aanlyn of vanlyn af",
        "LABEL": "Deelname",
        "OFFLINEUSER": "Vanlyn",
        "PLACEHOLDER": "Filter volgens tipe deelname",
        "USER": "Aanlyn"
      },
      "VISIBILITY": {
        "DRAFT": "Nie gepubliseer nie",
        "LABEL": "Sigbaarheid",
        "PLACEHOLDER": "Filter volgens sigbaarheid",
        "PLANNED": "Beplan",
        "PUBLISHED": "Gepubliseer"
      }
    },
    "MANAGE_FILTERS": {
      "DESCRIPTION": "Die filters word gestoor vir alle administrateurs en gemagtigde bestuurders.",
      "NO_FILTERABLE_QUESTIONS": "Geen filter beskikbaar nie.",
      "SECTION_TITLE_FORM": "Vorminligting",
      "SECTION_TITLE_PARTICIPANTS": "Deelnemersprofiel",
      "TITLE": "Filtreer"
    },
    "MENU": {
      "ASSIGNMENT": "Toewysings",
      "COMMUNICATION": "Nuus",
      "CONSULTATION": "Konsultasies",
      "FOLDER": "Lêers",
      "GENERAL": "Algemeen",
      "MESSAGING": "Boodskapdiens",
      "NEWSLETTER": "Nuusbriewe",
      "PARTICIPATION": "Deelname",
      "SETTINGS": "Instellings",
      "SETTINGS_ACCESS": "Toegang",
      "SETTINGS_COMMUNICATION": "Kommunikasie",
      "SETTINGS_GENERAL": "Algemeen",
      "SETTINGS_LEGAL": "Wettige teksste",
      "SETTINGS_PAGES": "Bladsye",
      "STATS": "Oorsig",
      "USER": "Gebruikers"
    },
    "NEWSLETTERS": "Nuusbriewe",
    "PARTICIPATION": "Deelname",
    "POSTS_FORM": {
      "FIELDS_CONFIG": {
        "ACTIVE": "Aktiveer",
        "APPLICATION_FILE_LABEL": "Voer 'n gedetailleerde lêermodel van aansoek in.",
        "APPLICATION_FILE_TOOLTIP": "Om bykomende inligting van gebruikers te vra wanneer 'n nuwe bydrae ingedien word, kan u hulle voorsien van 'n gedetailleerde aansoeklêersjabloon.<br></br><b>Aanvaarde formate:</b> .pdf, .doc, .docx, .txt, .odt, .rtf, .md",
        "DESCRIPTION": "Die indieningsvorm stem ooreen met die inligting wat die gebruiker moet invul om sy bydrae te lewer.",
        "REQUIRED": "Verpligtend",
        "TITLE": "Indienvorm"
      },
      "SETTINGS_PANEL": {
        "COMMUNICATION": {
          "TITLE": "Nuusinstellings"
        },
        "CONSULTATION": {
          "TITLE": "Konsultasie-instellings"
        },
        "FOLDER": {
          "TITLE": "Gidsinstellings"
        }
      },
      "TABS": {
        "ANALYSIS": "Ontleding",
        "APPEARANCE": "Voorkoms",
        "DISABLED_TOOLTIP": "Vul die huidige vorm in en stoor dit om toegang daartoe te verkry.",
        "IMPLEMENTATION": "Resultate",
        "MANAGERS": "Bestuurders",
        "PRESENTATION": "Voordrag",
        "PUBLIC_FILTERS": "Openbare filters",
        "QUESTIONS": "Vrae",
        "SECURITY": "Veiligheid",
        "SETTINGS": "Instellings",
        "SUBMISSION": "Belegging",
        "VOTE": "Stem"
      }
    },
    "PUBLIC_FILTERS": {
      "DESCRIPTION": "Voeg 'n gevorderde soektog by u konsultasie om gebruikers toe te laat om bydraes op u bladsy te filtreer.",
      "TITLE": "Publieke filters"
    },
    "SHOW": "Sien",
    "TABLE": {
      "ARIA_LABELS": {
        "FIRST_PAGE": "Eerste bladsy",
        "LAST_PAGE": "Laaste bladsy",
        "NEXT_PAGE": "Volgende bladsy",
        "PREVIOUS_PAGE": "Vorige bladsy"
      },
      "BUTTONS": {
        "ACTIONS": "Aksies",
        "CHANGE_STATUS": "Verander die status",
        "DELETE": "Verwyder"
      },
      "PAGINATION": "{from}-{to} van {count}",
      "TITLES": {
        "ACTIONS": "Aksies",
        "ASSIGNED": "Verantwoordelik",
        "AUTHOR": "Skrywer",
        "BIRTHDATE": "Geboortedatum",
        "BUDGET": "Koste",
        "COMMENTS_COUNT": "Kommentaar",
        "COMMUNICATIONS_COUNT": "Nuus",
        "CONSULTATION": "Consultasie",
        "CONSULTATIONS_COUNT": "Konsultasies",
        "CONSULTATION_TITLE": "Titel van die konsultasie",
        "CONTRIBUTION": "Bydrae",
        "CREATED_AT": "Uitnodigingsdatum",
        "EMAIL": "E-pos",
        "FIRST_NAME": "Voornaam",
        "FOLDER": "Lêergids",
        "FOLDERS_COUNT": "Lêers",
        "HAS_ACCESS": "Toegang?",
        "ID": "ID",
        "IDEAS_COUNT": "Bydraes",
        "LAST_NAME": "Naam",
        "LAST_VOTE_AT": "Stemming van datum",
        "NEWSLETTER_CREATED_AT": "Skeppingsdatum",
        "NEWSLETTER_SENT_AT": "Datum van versending",
        "NEWSLETTER_SUBJECT": "Onderwerp",
        "NEWSLETTER_TITLE": "nuusbrief",
        "PARTICIPATION_TYPE": "Deelname",
        "PICTURE": " ",
        "PUBLICATION_DATE": "Gepubliseer op",
        "RECIPIENTS": "Ontvangers",
        "RESPONSE_DATE": "Datum",
        "ROLE": "Rol",
        "SENT_AT": "Stuurdatum",
        "SOURCE": "Deelname",
        "STATE": "Staat",
        "STATUS": "Status",
        "SUBSCRIPTION_DATE": "Inskrywingsdatum",
        "TITLE": "Titel",
        "TOPIC": "Tematiese",
        "TYPE": "Tipe",
        "USER": "Gebruiker",
        "VISIBILITY": "Sigbaarheid",
        "VOTES_AGAINST_COUNT": "Stemme teen",
        "VOTES_COUNT": "Aantal stemme",
        "VOTES_FOR_COUNT": "Stemme vir"
      }
    }
  },
  "DATE": {
    "INPUT_FORMAT": "DD/MM/YYYY"
  },
  "DATE_TIME": {
    "DAYS_LEFT": "{count, plural, =0 {Laaste dag!} one {Daar is {count} dag oor!} other {Daar is {count} dae oor!}}",
    "INVALID_LABEL": "Ongeldig",
    "IN_N_DAYS": "Begin {count}",
    "LABEL": {
      "DEFAULT": "Kies 'n datum",
      "SCHEDULE_LABEL": "Publiseer die",
      "SCHEDULE_TITLE": "Beplan die publikasie"
    }
  },
  "DISCUSSION": {
    "EMAIL": {
      "CONTENT": {
        "LABEL": "Inhoud van die e-pos",
        "PLACEHOLDER": "Goeie dag, …"
      },
      "DELETED_USER_WARNING": "Hierdie gebruiker het verkies om hul rekening te verwyder. U kan hulle dus nie kontak nie.",
      "SEND": "Stuur",
      "SUBJECT": {
        "LABEL": "E-pos onderwerp",
        "PLACEHOLDER": "Versoek om aanvullende inligting oor …"
      }
    },
    "SHOW": {
      "COMMENTS_COUNT": "{count, plural, =0 {Privaat nota} one {{count} Privaat nota} other {{count} Privaat notas}}",
      "COMMENT_PLACEHOLDER": {
        "PRIVATE": "Voeg 'n privaat nota by",
        "PUBLIC": "Jou kommentaar"
      },
      "INFO": "Moet asseblief nie kommentaar skryf wat sensitiewe data bevat nie.",
      "INFO_TOOLTIP": "Ras- of etniese oorsprong, politieke, filosofiese of godsdienstige oortuigings, vakbondlidmaatskap, gesondheidsdata, seksuele voorkeur, kriminele rekord, …",
      "NO_COMMENTS": "Wees die eerste om 'n private nota te skryf."
    }
  },
  "DUPLICATED_POSTS": {
    "TITLE": "{count, plural, =0 {# soortgelyke bydraes saamgevoeg met hierdie een} one {{count} soortgelyke bydrae saamgevoeg met hierdie een} other {{count} soortgelyke bydraes saamgevoeg met hierdie een}}"
  },
  "ERROR_PAGES": {
    "BACK_TO_SPACE": "Keer terug na die tuisblad",
    "CTA_NO_SPACE": "Vind 'n deelnemingsruimte",
    "FORMER_CLIENT_TOAST": "Die ruimte wat jy probeer besoek, bestaan nie meer nie.",
    "NOT_FOUND": {
      "DESCRIPTION": "Dit lyk of ons jou op 'n verkeerde pad gelei het. Kom ons begin oor op 'n beter voet?",
      "TITLE": "Jammer, ons kon nie die bladsy wat jy gesoek het, vind nie."
    },
    "OFFLINE": {
      "DESCRIPTION": "Dit lyk of jy vanlyn is. Kom ons begin deur te verfris?",
      "TITLE": "Jammer, ons kon nie die bladsy wat jy gesoek het, vind nie."
    },
    "RELOAD": "Verfris",
    "SERVER_ERROR": {
      "DESCRIPTION": "Wees verseker dat ons ontwikkelaars alles in hul vermoë doen om dit reg te stel. Ons behoort binnekort weer terug te wees.",
      "TITLE": "Oeps, 'n onverwags fout het voorgekom."
    }
  },
  "FOOTER": {
    "ACCESSIBILITY": "Toeganklikheid",
    "ETHICAL_POLICY": "Etiese Handves",
    "HELP": "Hulp",
    "LEGAL_NOTICE": "Regswysigings",
    "PRIVACY_POLICY": "Privaatheidsbeleid",
    "TERMS_OF_USE": "Gebruiksvoorwaardes"
  },
  "FORM": {
    "ERRORS": {
      "FILL_CORRECTLY": "U moet die velde korrek invul.",
      "REQUIRED": "U moet hierdie veld invul."
    },
    "SELECT_EMPTY_LABEL": "Nie gespesifiseer nie",
    "TOASTS": {
      "DELETED_SUCCESSFULLY": "Suksesvol uitgevee",
      "UPDATED_SUCCESSFULLY": "Opdatering suksesvol voltooi"
    }
  },
  "FORM_RESPONSES": {
    "CREATED_AT": "Beantwoord op <b>{date}</b> om <b>{time}</b>",
    "SHOW_RESPONSE": "Sien my antwoord",
    "SUBMISSION_NOT_ONGOING": "Die konsultasie is gesluit, jy kan nie meer antwoord of jou antwoord wysig nie.",
    "UPDATE_RESPONSE": "Wysig my antwoord"
  },
  "GENERIC_CONFIRM_DELETE": {
    "CONTENT": "Is jy seker jy wil hierdie item verwyder?",
    "CTA": "Ja, verwyder",
    "TITLE": "Verwyder"
  },
  "HOME": {
    "PAGE_TITLE": "Welkom by Fluicity Engage",
    "SEARCH_PLACEHOLDER": "Voer die naam van die ruimte in",
    "SUBTITLE": "Vind 'n ruimte om deel te neem"
  },
  "IMAGE": {
    "FAILED_TO_LOAD": "Die laai van die beeld het misluk.",
    "LOADING": "Laai beeld..."
  },
  "IMPORT": {
    "CONTRIBUTIONS": {
      "HEADLINE": {
        "DESCRIPTION": "Om verskeie bydraes wat buite die platform ontvang is by te voeg, {link} sonder om die formaat te verander.<br></br>As u nie sekere inligting versamel het nie, moet asseblief nie die kolomme uitvee nie en dit leeg laat.<br></br>As u bydraes in verskillende tale is, vertaal asseblief almal na {defaultLang} voordat u dit invoer.",
        "LINK": "Vul die model in",
        "TITLE": "Voer bydraes in"
      },
      "STATUS": {
        "DESCRIPTION": "Wys die status van die bydraes tydens die invoer",
        "TITLE": "Kies die status"
      }
    },
    "ERROR": {
      "DESCRIPTION": "Dit is onmoontlik om jou lêer in te voer. Maak seker dat jou lêer aan die model voldoen.",
      "EXPLANATION": "Maak seker dat geen kolom verwyder is nie en dat die antwoorde die vereiste formaat respekteer.",
      "ROWS_MULTIPLE": "Kan nie jou lêer invoer nie. Foute is geïdentifiseer op reëls {rows}.",
      "ROWS_SINGLE": "Dit is onmoontlik om jou lêer in te voer. 'n Fout is op lyn {rows} geïdentifiseer.",
      "ROWS_WITH_MORE": "Dit is onmoontlik om u lêer in te voer. Foute is geïdentifiseer op reëls {rows} en {moreCount} ander."
    },
    "FORM": {
      "CTA": "Invoer",
      "UPLOAD_DATE": "{size} - Opgedateer op {date}",
      "UPLOAD_TITLE": "Sleep die lêer of klik"
    },
    "FORM_RESPONSES": {
      "HEADLINE": {
        "DESCRIPTION": "Om verskeie antwoorde wat buite die platform ontvang is by te voeg, {link} sonder om die formaat te verander.<br></br>As jy nie sekere inligting ingesamel het nie, moenie die kolomme verwyder nie en laat dit asseblief leeg.<br></br>As jou antwoorde in verskeie tale is, vertaal asseblief almal na {defaultLang} voordat jy dit invoer.",
        "LINK": "vul die model in",
        "TITLE": "Antwoorde invoer"
      }
    },
    "PREVIEW": {
      "DESCRIPTION": "Maak seker dat die inligting van u invoer ooreenstem met die kolomme van die model.<br></br>As daar inligting is wat nie ooreenstem nie, moet u u lêer wysig en dan u bygewerkte lêer invoer.",
      "TITLE": "Kontroleer die data"
    },
    "PROGRESS": "Besig om in te voer…",
    "VOTERS": {
      "HEADLINE": {
        "DESCRIPTION": "Om stemme buite die platform by te voeg, {link} sonder om die formaat te verander. As jy nie sekere inligting versamel het nie, moet asseblief <b>nie die kolomme verwyder nie</b> en laat dit leeg.",
        "LINK": "Vul die model in",
        "TITLE": "Stemme invoer"
      }
    }
  },
  "JOIN": "Aansluit",
  "JOINED_SPACE": "Jy het aangesluit by {space}, welkom!",
  "KEEP_ME_ALIVE": {
    "ALERT": {
      "CONTENT": "Ons sal u op hoogte hou as daar in die toekoms relevante konsultasies vir u uitgesaai word. U kan ook ander bestaande ruimtes vind deur die onderstaande soektog te gebruik en aan te meld met u huidige rekening.",
      "CONTENT_NOT_FOUND": "Om weer aan 'n konsultasie deel te neem, skep asseblief 'n nuwe rekening.",
      "TITLE": "Dankie dat u gekies het om u rekening aktief te hou!",
      "TITLE_NOT_FOUND": "Jou rekening bestaan nie meer nie of is reeds geanonimiseer!"
    }
  },
  "LOADING_MORE": "Laai tans…",
  "LOAD_MORE": "Sien meer",
  "MENU_ITEMS": {
    "DESCRIPTION": "Pas die oortjies aan wat in jou navigasiebalk verskyn.",
    "FORM": {
      "ADD_ITEM": "Voeg 'n oortjie by",
      "ADD_SUBITEM": "Voeg 'n sub-oortjie by",
      "INPUTS": {
        "LABEL": {
          "LABEL": "Etiket",
          "PLACEHOLDER": "Gee die opskrif van u oortjie aan"
        },
        "LINK": {
          "LABEL": "Eksterne skakel",
          "PLACEHOLDER": "https://site.com"
        },
        "PAGE": {
          "LABEL": "Standaardbladsy",
          "PLACEHOLDER": "Kies 'n bladsy"
        },
        "POST": {
          "LABEL": "Inhoud",
          "NO_OPTIONS": "Geen inhoud gevind nie",
          "PLACEHOLDER": "Soek 'n inhoud"
        },
        "POST_CATEGORY": {
          "COMMUNICATION": "Nuus",
          "CONSULTATION": "Konsultasies",
          "FOLDER": "Lêer",
          "LABEL": "Inhoud tipe",
          "PLACEHOLDER": "Kies 'n inhoudstipe"
        },
        "TYPE": {
          "LABEL": "Tipe",
          "PLACEHOLDER": "Kies 'n tipe"
        }
      }
    },
    "GROUP": "Kieslys",
    "LINK": "Eksterne skakel",
    "NEW_GROUP": "NUWE KEUSELYs",
    "NEW_ITEM": "NUWE ITEM",
    "PAGE": "Verstekbladsy",
    "PAGE_ABOUT": "Oor ons",
    "PAGE_CONSULTATIONS": "Konsultasies",
    "PAGE_NEWS": "Nuus",
    "PAGE_SEARCH": "Soek",
    "POST": "Inhoud",
    "TITLE": "Jou navigasie-balk"
  },
  "MESSAGING_BLOC": {
    "ANOMALY": {
      "REPORT_CTA": "Meld 'n onreëlmatigheid aan"
    },
    "DEMAND": {
      "REPORT_CTA": "Stuur 'n boodskap"
    }
  },
  "META_TAGS": {
    "DEFAULT_DESCRIPTION": "Fluicity Engage is 'n oplossing vir burgerbetrokkenheid, wat kollektiewe besluitneming oor algemene belangeonderwerpe moontlik maak.",
    "PAGES_TITLES": {
      "ABOUT": "Oor | {spaceName}",
      "CONSULTATIONS": "Konsultasies | {spaceName}",
      "CONTRIBUTIONS": {
        "MESSAGING": "My boodskappe & afwykings | {spaceName}",
        "PROPOSALS": "My bydraes | {spaceName}"
      },
      "DASHBOARD": "Dashboard | {spaceName}",
      "LEGAL_NOTICE": "Wettige Vermeldings | {spaceName}",
      "NEWS": "Nuus | {spaceName}",
      "PRIVACY_POLICY": "Privaatheidsbeleid |{spaceName}",
      "SEARCH": "Soek | {spaceName}",
      "SETTINGS": "My rekening | {spaceName}",
      "TERMS_OF_USE": "Gebruiksvoorwaardes | {spaceName}"
    },
    "STATUS_TO_SHARE": {
      "ARTICLE": "{cityName} : ontdek hierdie artikel op Fluicity Engage!",
      "EVENT": "{cityName} : neem deel aan hierdie geleentheid!",
      "FOLDER": "{title} {url}",
      "IDEA": "Ondersteun hierdie bydrae: {title} {url}"
    },
    "TITLE_TO_SHARE": {
      "FOLDER": "{titel}",
      "IDEA": "Ondersteun hierdie bydrae: {title}"
    }
  },
  "MODERATION": {
    "MODAL": {
      "DESCRIPTION": "U kan u bydrae wysig of dit indien soos dit is. Die dienste sal evalueer of u bydrae gepubliseer kan word of nie.",
      "REASON": "Rede:",
      "SUBMIT": "Indien die vertaling van \"Soumettre\" na Afrikaans verlang word, is die korrekte vertaling \"Voorlê\".",
      "TITLE": "Jou bydrae is as verdag geïdentifiseer."
    }
  },
  "MOMENT": {
    "DATE": {
      "DEFAULT": "DD/MM/YYYY",
      "PLACEHOLDER": "JJ/MM/JJJJ"
    }
  },
  "NAVBAR": {
    "DASHBOARD": "Dashboard",
    "MY_ACCOUNT": "My rekening",
    "MY_PROFILE": "My profiel"
  },
  "NEWSLETTERS": {
    "ALREADY_SENT": "Hierdie nuusbrief is reeds gestuur.",
    "CREATED_AT": "Geskep op <b>{date}</b> om <b>{time}</b>",
    "DRAFT": "Konsep",
    "FORM": {
      "CLEAR_SCHEDULING": "Kansellasie van die beplanning.",
      "CONTENT": {
        "LABEL": "Inhoud",
        "PLACEHOLDER": "Inhoud van die e-pos"
      },
      "RECIPIENTS": {
        "ALL": "Alle gebruikers",
        "LABEL": "Ontvangers",
        "PLACEHOLDER": "Kies die ontvangers"
      },
      "SAVE_SUCCESS": "Jou nuusbrief is suksesvol geregistreer.",
      "SCHEDULE": "Beplan die versending",
      "SCHEDULED_AT": "Datum van versending",
      "SEND": "Stuur",
      "SEND_SUCCESS": "Jou nuusbrief is suksesvol gestuur.",
      "SEND_TEST": "Stuur die toets",
      "SUBJECT": {
        "LABEL": "Onderwerp",
        "PLACEHOLDER": "Onderwerp van die e-pos"
      },
      "TEST_EMAIL": {
        "LABEL": "Toets e-posadresse",
        "PLACEHOLDER": "Voer die toets e-posadresse in (geskei deur kommas)"
      },
      "TEST_SUCCESS": "Jou toets nuusbrief is suksesvol gestuur"
    },
    "IMMEDIATELY": "Onmiddellik",
    "NEW_NEWSLETTER": "Skep 'n nuusbrief",
    "SCHEDULED": "Beplan",
    "SENT": "Gestuur",
    "SENT_AT": "Gestuur op <b>{date}</b> om <b>{time}</b>",
    "UPDATE_NEWSLETTER": "Wysig die nuusbrief",
    "USERS_FILTER_COUNT": "{count, plural, =0 {Geen ontvanger is gevind vir hierdie seleksie nie} one {Jou nuusbrief sal aan 1 persoon gestuur word} other {Jou nuusbrief sal aan {count} persone gestuur word}}"
  },
  "NEXT": "Volgende",
  "NONE": "Geen",
  "NOTIFICATIONS_SETTINGS": {
    "ADMINISTRATOR": {
      "DAILY_DIGEST": {
        "DESCRIPTION": "Konsultasies :<br />• Nuwe bydraes<br />• Nuwe antwoorde op opnames<br />• Wanneer 'n burger op een van my opmerkings antwoord<br />• Wanneer 'n fase of 'n konsultasie binnekort eindig<br /><br />Boodskapdiens :<br />• Nuwe boodskappe<br />• Nuwe afwykings<br />• Wanneer 'n burger op een van my opmerkings antwoord",
        "SUBTITLE": " (daagliks)",
        "TITLE": "Laaste aktiwiteite"
      },
      "SUBSCRIBED_ACTIVITIES_NOTIFICATIONS": {
        "DESCRIPTION": "• Wysiging van 'n bydrae deur sy skrywer<br />• Moderering van inhoud deur die Fluicity Engage-span",
        "TITLE": "Ander"
      }
    },
    "CITIZEN": {
      "CONSULTATIONS_NOTIFICATIONS": {
        "DESCRIPTION": "• Nuwe konsultasie<br />• Begin van 'n fase van ideevorming, stemming of resultate",
        "TITLE": "Konsultasies"
      },
      "DAILY_DIGEST": {
        "DESCRIPTION": "• Kommentaar of stem oor my bydrae<br />Antwoord op my kommentaar<br />Verandering van status van my bydrae",
        "SUBTITLE": " (daagliks)",
        "TITLE": "Jou laaste aktiwiteite"
      },
      "NEWSLETTER_NOTIFICATIONS": {
        "DESCRIPTION": "• Nuusbriewe oor die aktiwiteite van die platform",
        "TITLE": "Nuusbriewe"
      },
      "SUBSCRIBED_ACTIVITIES_NOTIFICATIONS": {
        "DESCRIPTION": "• Verwydering van 'n bydrae wat jy kommentaar gelewer het<br />• Moderering van inhoud wat jy kommentaar gelewer het",
        "TITLE": "Ander"
      },
      "WEEKLY_DIGEST": {
        "DESCRIPTION": "• Nuwe artikels<br />• Nuwe geleenthede<br />• Gewilde bydraes",
        "SUBTITLE": "(weekliks)",
        "TITLE": "Op die oomblik in die ruimte"
      }
    },
    "INFO_BOX_TEXT": "Kies hier die e-pos kennisgewings wat jy van die platform wil ontvang."
  },
  "NPS_FORM": {
    "CONTENT_FIELD": "Hoekom?",
    "EXTREMELY_LIKELY": "Heeltemal",
    "NOT_LIKELY": "Glad nie",
    "TITLE": "Help ons om Fluicity Engage te verbeter",
    "VALUE_QUESTION": "Sou jy Fluicity Engage aan 'n kollega aanbeveel?"
  },
  "OFFLINE": "Aflynend",
  "ONLINE": "Aanlyn",
  "OR": "OF",
  "ORIGINAL_POST": {
    "NO_OPTIONS": "Geen bydrae kan gekies word nie.",
    "TITLE": "Hierdie bydrae is saamgevoeg met die volgende soortgelyke bydrae."
  },
  "PAGE_OF": "Bladsy {current} van {total}",
  "PASSWORD_RESET": {
    "ACTION": "opdateer",
    "ARIA_LABEL": "Wissel die sigbaarheid van die wagwoord",
    "PAGE_TITLE": "Skep 'n nuwe wagwoord",
    "TITLE": "Skep 'n nuwe wagwoord",
    "TOAST": "Die nuwe wagwoord is gestoor."
  },
  "PASSWORD_RESET_REQUEST": {
    "HOMEPAGE_LINK": "Keer terug na die tuisblad",
    "LINK_SENT": "As 'n rekening gekoppel is aan die e-pos <strong>{email}</strong>, sal jy 'n skakel vir terugstelling ontvang. <br></br><br></br>As jy nie 'n e-pos sien nie, kyk in jou gemorspos.",
    "PAGE_TITLE": "Herstel jou wagwoord",
    "RESET": "Herstel",
    "SUB_TITLE": "Het lyk of jy jou wagwoord vergeet het? Dit gebeur met almal! Ons sal vir jou 'n e-pos stuur met 'n skakel om dit te herstel.",
    "TITLE": "Stel jou wagwoord terug"
  },
  "PICTURE_PICKER": {
    "COVER": "Kies 'n beeld om jou publikasie te illustreer"
  },
  "POSTS": {
    "AUDITS": {
      "CREATE": "geskep {date}",
      "MODAL": {
        "AFTER": "Na wysiging",
        "BEFORE": "Voor wysiging",
        "TITLE": "Geskiedenis"
      },
      "NO_AUDITS": "Hierdie bydrae is nog nie opgedateer nie.",
      "UPDATE": "Opgedateer {date}"
    },
    "AUTHOR": "Skrywer",
    "BUDGET": {
      "ALERT": "Jy moet <b>die koste aandui</b> van die bydrae voordat jy dit as 'Retensie' definieer.",
      "BUDGET_VALUE": "Hierdie bydrae kos <b>{budget}</b>",
      "MODAL_LABEL": "Koste van die bydrae",
      "MODAL_TITLE": "Vul die koste in",
      "NOT_ENOUGH_BUDGET": "Die oorblywende begroting is onvoldoende.",
      "NOT_SELECTED": "Hierdie bydrae is nie vir die stemfase behou nie.",
      "REMAINING_BUDGET": "Jy het nog <strong>{remaining}</strong> om te bestee."
    },
    "CARD": {
      "CONTRIBUTE": "Bydrae",
      "PARTICIPATE": "Deelnemen",
      "READ_MORE": "Raadpleeg",
      "VOTE": "Stemmer"
    },
    "CAROUSEL": {
      "PROGRESS": {
        "TOOLTIP_1": "{progress, plural, =0 {{progress} stem} one {{progress} stem} other {{progress} stemme}}",
        "TOOLTIP_2": "{total, plural, =0 {uit {total} bydrae} one {uit {total} bydrae} other {uit {total} bydraes}}"
      },
      "PROMPT": {
        "PROPOSAL_CARD": {
          "CTA": "Bydrae",
          "TEXT_1": "Of as jy inspirasie het",
          "TEXT_2": "Maak ons 'n bydrae?"
        },
        "VOTE_CARD": {
          "CTA": "Stemmers",
          "TEXT_1": "Jy het reeds 'n paar bydraes deurgegaan {emoji}",
          "TEXT_2": "gaan aan?",
          "TEXT_3": "of sien die volledige lys"
        }
      }
    },
    "CLONE": {
      "ACTION": "Dupliseer",
      "CANCEL": "Nee",
      "CONFIRM": "Ja, dupliseer",
      "CONTENT_CLONED": "Hierdie inhoud is suksesvol gedupliseer.",
      "DESCRIPTION": "Wil u regtig hierdie inhoud dupliseer?",
      "SUCCESS": "Hierdie inhoud is verwyder."
    },
    "COMMENTS_COUNT": "{count, plural, =0 {Kommentaar} one {Kommentaar} other {Kommentaar}}",
    "CONSULTATIONS": {
      "BE_THE_FIRST_TO_PARTICIPATE": "Wees die eerste om deel te neem!",
      "CONSULTATIONS_COUNT": "{count, plural, =0 {{count} konsultasie} one {{count} konsultasie} other {{count} konsultasies}}",
      "ENDED_AT": "Die konsultasie het op {date} geëindig.",
      "FEED_TITLE": {
        "IDEAS_COUNT": "{itemCount, plural, =0 {Geen bydrae} one {# bydrae} other {# bydraes} }",
        "LOCATED_IDEAS_COUNT": "{itemCount, plural, =0 {Geen gelokaliseerde bydraes} one {1 gelokaliseerde bydrae} other {# gelokaliseerde bydraes}}"
      },
      "MAP_TOOLTIP": "Bydraes wat nie gegroeiokaliseer is nie, verskyn nie op die kaart nie. 'n Bydrae kan verskeie lokaliserings hê.",
      "NEWS_COUNT": "{count, plural, =0 {nuus} one {{count} nuus} other {{count} nuus}}",
      "ONGOING_TEXT": "Maak hier 'n afspraak om deel te neem.",
      "PARTICIPATE_OFF": "Kom binnekort hierheen om by te dra tot die bydraes!",
      "POST_SIDE_PRIMARY_ACTION": {
        "IMPLEMENTATION": "Ontdek die resultate",
        "PARTICIPATE": "Neem deel aan die konsultasie"
      },
      "SEE_OWN_VOTES": "Sien slegs my stemme",
      "STARTS_AT": "Die konsultasie begin op {date}",
      "STEP_ENDED_AT": "Die fase “{step}” is op {date} beëindig.",
      "STEP_STARTS_AT": "Kom ons ontmoet op {date} om die fase “{step}” te ontdek."
    },
    "CONTENT_DELETED_SUCCESSFULLY": "die inhoud is verwyder",
    "CREATE_MENU": {
      "ACTIONS": "Aksies",
      "ADDED_TO_FOLDER_TOAST": "Inhoud by die lêer gevoeg.",
      "ADD_TO_FOLDER": "Voeg by 'n lêergids",
      "ARTICLE": {
        "DESCRIPTION": "'n Nuus of 'n inisiatief aanbied"
      },
      "ASSIGN": "Toewys",
      "BUTTON": "Skep",
      "COLLABORATIVE_DECISION": {
        "DESCRIPTION": "Implementering van bydraes wat saam met gebruikers mede-gebou is."
      },
      "CONTACT_AUTHOR": "Kontak die outeur",
      "DIALOG_TITLE": {
        "COMMUNICATION": "Skep 'n nuusberig",
        "CONSULTATION": "Stel 'n konsultasie op"
      },
      "EDIT": "Wysiger",
      "EVENT": {
        "DESCRIPTION": "Nooi om aan 'n byeenkoms deel te neem"
      },
      "FOLDER": {
        "DESCRIPTION": "Skep 'n bladsy om inhoud te sentraliseer"
      },
      "IDEAS_REQUEST": {
        "DESCRIPTION": "Versamel bydraes oor jou strategiese kwessies."
      },
      "MERGE": "Groepeer die bydrae",
      "PARTICIPATORY_BUDGET": {
        "DESCRIPTION": "Ken 'n begroting toe aan bydraes wat saam met die gebruikers mede-ontwikkel is."
      },
      "PIN": "Beklemtoon",
      "REMOVED_FROM_FOLDER_TOAST": "Inhoud uit die lêer verwyder.",
      "REPORT": "Rapporteer",
      "STEPS_COUNT": "{count, plural, one {# stap} other {# stappe}}",
      "STUDY": {
        "DESCRIPTION": "'n Enquête wat buite die platform geskep is, integreer",
        "TITLE": "Vraelys - Integrasie"
      },
      "SURVEY": {
        "DESCRIPTION": "Vra die gebruikers oor 'n spesifieke onderwerp en versamel genuanseerde inligting."
      },
      "UNPIN": "Nie meer voorop stel nie",
      "UNPUBLISH": "Afhaal",
      "UPDATE_BUDGET": "Vul die begroting in",
      "UPDATE_STATUS": "Verander die status",
      "VIEW": "Sien die publikasie",
      "VIEW_IN_DASHBOARD": "Paneelbord",
      "VIEW_POST": "Sien die publikasie"
    },
    "DELETE": {
      "ACTION": "Verwyder",
      "CANCEL": "Geen",
      "CONFIRM": "Ja, verwyder",
      "CONTENT_DELETED": "Hierdie inhoud is verwyder.",
      "DESCRIPTION": "Wil jy regtig hierdie inhoud verwyder?",
      "PLACEHOLDER": "Voeg 'n opmerking by om u verwydering te verduidelik.",
      "REASON": "Kommentaar",
      "SELECT_REASON": "Gee aan waarom u hierdie inhoud verwyder:",
      "SUCCESS": "Hierdie inhoud is verwyder."
    },
    "DETAILS": {
      "AUTHORED_BY": "Gedra deur {name}",
      "DESCRIPTION_TITLE": "Beskrywing",
      "EVENT": {
        "ACCESS_THE_EVENT": "Toegang tot die gebeurtenis",
        "EVENT_URL": "Videokonferensie",
        "STATE": {
          "FUTURE": "Die geleentheid begin op <b>{date}</b> om <b>{time}</b>.",
          "ONGOING": "Die gebeurtenis is aan die gang.",
          "PAST": "Die geleentheid is verby"
        }
      },
      "MORE_TAGS": "{count, plural, one {en nog 'n ander tema} other {en {count} ander temas}}",
      "STUDY": {
        "JOIN_BUTTON": "Aansluit",
        "JOIN_DESCRIPTION": "Teken in of registreer om toegang tot die konsultasie te verkry!",
        "PARTICIPATE": "Deelneem",
        "POST_SIDE_DESCRIPTION": {
          "COMING": "Die konsultasie begin op {date}.",
          "ENDED": "Die konsultasie is op {date} voltooi.",
          "ONGOING_ANSWERED": "Dankie vir u deelname, dit is goed in ag geneem."
        },
        "SEE_RESULTS": "Sien die resultate"
      },
      "UPDATE_MY_IDEA": "Wysiger"
    },
    "EXPORT": {
      "BUTTON": "Uitvoerder",
      "IDEAS": "Alle bydraes",
      "MESSAGES": "Alle boodskappe"
    },
    "FILTER_BY_IS_PINNED": "Hoofnuus",
    "FILTER_BY_PUBLISHED": "Gepubliseer",
    "FILTER_BY_STATUS": "Status",
    "FILTER_BY_TAGS": "Tema",
    "FILTER_BY_TYPE": "Inhoud tipe",
    "FILTER_IS_PINNED_TRUE": "Ja",
    "FILTER_PUBLISHED_FALSE": "Nie gepubliseer nie",
    "FILTER_PUBLISHED_TRUE": "Gepubliseer",
    "FILTER_STATUS_ANSWERED": "Nie behou nie",
    "FILTER_STATUS_DOING": "Besig met ontleding",
    "FILTER_STATUS_DONE": "Gerealiseer",
    "FILTER_STATUS_IN_PROGRESS": "Besig met uitvoering",
    "FILTER_STATUS_SELECTED": "Inhouding",
    "FILTER_STATUS_TODO": "Geplaas",
    "FILTER_STATUS_VALIDATED": "Lauréaat",
    "FILTER_TYPE_ANOMALY": "Anomalie",
    "FILTER_TYPE_ARTICLE": "Artikel",
    "FILTER_TYPE_COLLABORATIVE_DECISION": "Oorlegging",
    "FILTER_TYPE_DEMAND": "Boodskap",
    "FILTER_TYPE_EVENT": "Gebeurtenis",
    "FILTER_TYPE_FOLDER": "Dossier",
    "FILTER_TYPE_IDEA": "Bydrae",
    "FILTER_TYPE_IDEAS_REQUEST": "Oproep tot bydraes",
    "FILTER_TYPE_PARTICIPATORY_BUDGET": "Deelnemende begroting",
    "FILTER_TYPE_STUDY": "Vraelys",
    "FOLDER": {
      "IS_OPEN_TO_PROPOSITIONS": "Oop vir spontane bydraes"
    },
    "FORM": {
      "ADDRESS": {
        "LABEL": "Plek",
        "PLACEHOLDER": "Voeg 'n plek by"
      },
      "CATEGORIES": {
        "LABEL": "Temas",
        "PLACEHOLDER": "Kies die temas van die konsultasie",
        "SELECT_ALL": "Kies alles"
      },
      "CATEGORY": {
        "LABEL": "Tematiese",
        "PLACEHOLDER": "Kies 'n tema"
      },
      "CONTENT": "Beskrywing",
      "PICTURE": {
        "BUTTON": {
          "ADD_FILE_OR_PICTURE": "Voeg 'n lêer/beeld by",
          "ADD_PICTURE": "Voeg 'n beeld by",
          "DELETE_PICTURE": "Verwyder"
        },
        "ERRORS": {
          "FILE_SIZE": "Die grootte van die beeld moet nie {fileSize}Mo oorskry nie.",
          "FILE_TYPE": "Die beeld moet in {fileTypes}-formaat wees."
        },
        "TOOLTIP": "Aanbevole grootte: {width} (wydte) by {height} pixels (hoogte) <br></br> Aanvaarde formate: .jpg, .jpeg, .png"
      },
      "PIN": "Hierdie inhoud word beklemtoon.",
      "TITLE": "Titel",
      "UNPIN": "Hierdie inhoud is nie meer op die voorgrond nie."
    },
    "HOW_IT_WORKS": {
      "TITLE": "Hoe werk dit?"
    },
    "INDICATORS": {
      "ATTENDEES": "Deelnemers",
      "COMMENTS": "Kommentaar",
      "COMMUNICATIONS": "Nuus",
      "CONSULTATIONS": "Konsultasies",
      "IDEAS": "Bydraes",
      "VOTES": "{online_count, plural, =0 {{online_count} stem aanlyn} one {{online_count} stem aanlyn} other {{online_count} stemme aanlyn}} - {offline_count, plural, =0 {{offline_count} stem vanlyn} one {{offline_count} stem vanlyn} other {{offline_count} stemme vanlyn}}"
    },
    "INTERACTIONS_BOX": {
      "CONTINUE_CONVERSATION": "Fortsit die gesprek",
      "GIVE_YOUR_OPINION": "Gee jou mening"
    },
    "PREVIEW": "Kyk op die webwerf",
    "PUBLIC_STUDY": "Openbare ondersoek",
    "PUBLISHED": "Gepubliseer",
    "PUBLISHED_AT": "Gepubliseer op {date}",
    "PUBLISH_CANCELED": "Die publikasie van hierdie inhoud is gekanselleer.",
    "PUBLISH_EDIT": "Wysig die beplanning",
    "PUBLISH_NOW": "Publiseer nou",
    "PUBLISH_NOW_TOASTER": "Jou inhoud is nou sigbaar vir gebruikers.",
    "PUBLISH_SCHEDULED": "Beplan die publikasie",
    "REPORT": {
      "ACTION": "Aandui",
      "CODE_OF_ETHICS": "etiese handves",
      "CONFIRM": "Stuur",
      "EMPTY_ERROR": "U moet die velde korrek invul.",
      "FLUICITY_TERMS_PART_A": "Meer te wete kom oor die",
      "FLUICITY_TERMS_PART_B": "en die",
      "FLUICITY_TERMS_PART_C": "van Fluicity Engage.",
      "PLACEHOLDER": "Voeg 'n opmerking by om jou verslag in detail te beskryf.",
      "SELECT_REASON": "Gee aan waarom jy hierdie inhoud rapporteer:",
      "SUCCESS": "Dankie vir hierdie aanmelding. Dit stel ons in staat om gehalte-inhoud op Fluicity Engage te verseker.",
      "TERMS_OF_USE": "Algemene Voorwaardes"
    },
    "RESPONSES_COUNT": "{count, plural, =0 {Antwoord} one {Antwoord} other {Antwoorde}}",
    "SAVE": "Stoor",
    "SAVE_THE_DRAFT": "Stoor die konsep",
    "SCHEDULE": "Programmeerder",
    "SCHEDULED": "Geprogrammeer",
    "SCHEDULED_AT": "Geskeduleer op {datum}",
    "SCHEDULED_AT_TOASTER": "Die publikasie van hierdie inhoud is beplan vir {datum}",
    "SEE": {
      "COLLABORATIVE_DECISION": "Sien die konsultasie",
      "FOLDER": "Sien die lêer",
      "IDEA": "Sien die bydrae",
      "IDEAS_REQUEST": "Kyk na die oproep vir bydraes",
      "PARTICIPATORY_BUDGET": "Sien die deelnemende begroting"
    },
    "SHOW": {
      "FROM_DATE_TO_DATE_WITH_TIME": "Van <strong>{startAtDate} om {startAtHour}</strong> tot <strong>{endAtDate} om {endAtHour}</strong>",
      "QR_CODE": {
        "BLACK_AND_WHITE": "Swart en wit",
        "DOWNLOAD": "Aflaai",
        "GENERATE": "Genereer die QR-kode",
        "TITLE": "QR-kode"
      },
      "SHARE_IT": "Deel"
    },
    "SORT": {
      "BUTTON": "Probeer",
      "POPULAR": "Gewild",
      "RECENT": "Onlangs"
    },
    "STATS": {
      "TITLE_PARTICIPATION": "Opsomming van deelname"
    },
    "STATUS": {
      "FORM_TITLE": "{count, plural, =0 {Verander die status} one {Verander die status} other {Verander die status: {count} bydraes gekies}}",
      "MODAL": {
        "TITLE": "Vordering van 'n bydrae"
      },
      "ORIGINAL_POST": {
        "LABEL": "Titel van die oorspronklike bydrae wat behou sal word",
        "TITLE": "Verskaf die titel van die oorspronklike bydrae waaraan hierdie bydrae gegroepeer moet word:"
      },
      "POPOVER": {
        "BUTTON": "Kom meer te wete"
      },
      "SUBMIT": "Stoor",
      "TITLE": "Status",
      "UPDATED_SUCCESSFULLY": "Die status is gestoor."
    },
    "STEPS": {
      "STATES": {
        "AVAILABLE": "Beskikbaar",
        "COMING": "Kommende",
        "ENDED": "Voltooi",
        "ENDLESS": "Deurlopend",
        "ONGOING": "Besig"
      },
      "TABS": {
        "LABEL": "Fases van publikasie-seleksie-oortjies"
      }
    },
    "SUMMARY": {
      "TITLE": "Opsomming van bydrae",
      "TOOLTIP": "Hierdie opsomming is gegenereer met die hulp van kunsmatige intelligensie om die lees van die bydrae vir u te vergemaklik."
    },
    "TAGS": {
      "PERIOD": "Van <strong>{startAtDate} om {startAtHour}</strong> tot <strong>{endAtDate} om {endAtHour}</strong>",
      "PERIOD_SAME_DAY": "Op <strong>{startAtDate}</strong> van <strong>{startAtHour}</strong> tot <strong>{endAtHour}</strong>",
      "PERIOD_SHORT": "Van <strong>{startAtDate}</strong> tot <strong>{endAtDate}</strong>"
    },
    "TYPES": {
      "ANOMALY": "Anomalie",
      "ARTICLE": "Artikel",
      "COLLABORATIVE_DECISION": "Oorlegging",
      "DEMAND": "Boodskap",
      "EVENT": "Gebeure",
      "FOLDER": "Dossier",
      "IDEA": "Bydrae",
      "IDEAS_REQUEST": "Oproep vir bydraes",
      "PARTICIPATORY_BUDGET": "Deelnemende begroting",
      "STUDY": "Vraelys",
      "SURVEY": "Vraelys"
    },
    "UPDATED": "Die inhoud is suksesvol opgedateer."
  },
  "POST_FORM": {
    "ACTION_SAVE": "Stoor",
    "ADMIN_UPDATE_ALERT": "Wanneer u 'n bydrae wysig, stuur ons outomaties 'n kennisgewing per e-pos aan die outeur. Om te verseker dat die outeur saamstem met u wysiging, beveel ons aan dat u hom direk vooraf kontak.",
    "APPLICATION_FILE": "Laai jou gedetailleerde aansoeklêer op",
    "APPLICATION_FILE_BUTTON": "Voeg 'n lêergids by",
    "APPLICATION_FILE_TOOLTIP": "Om u bydrae in te dien, moet u noodwendig 'n gedetailleerde aansoeklêer verskaf. Vul die voorsien model in en laai dit hier onder op.<br></br><br></br>In teenstelling met die inligting wat in die res van die vorm verskaf word (titel, beskrywing, tema, ens.) wat openbaar sal wees, sal die inhoud van die lêer slegs toeganklik wees deur die administrateurs van die platform.<br></br><br></br><b>Aanvaarde formate:</b> .pdf, .doc, .docx, .txt, .odt, .rtf, .md",
    "ATTACHMENTS": {
      "DESCRIPTION": {
        "COMMUNICATION": "Deel aanvullende dokumente soos beelde of 'n video by u nuus.",
        "CONSULTATION": "Deel aanvullende dokumente soos u regulasie, beelde of 'n video by u konsultasie.",
        "FOLDER": "Deel aanvullende dokumente soos beelde of 'n video aan jou lêer."
      },
      "TITLE": "Aangehegte lêers"
    },
    "ATTACHMENTS_FILES": "Lêers",
    "ATTACHMENTS_IMAGES": "Beelde",
    "ATTACHMENTS_TITLE": "Dokumente",
    "AUTHORED_BY": "Wie is die outeur?",
    "AUTHORED_BY_A_THIRD_PARTY": "'n Derde party",
    "AUTHORED_BY_A_THIRD_PARTY_PLACEHOLDER": "'n persoon buite die platform",
    "AUTHORED_BY_CUSTOM": "Gepersonaliseerd",
    "AUTHORED_BY_CUSTOM_PLACEHOLDER": "Vereniging, groep burgers, vergadering…",
    "AUTHORED_BY_FIRST_NAME": "Voornaam van die outeur",
    "AUTHORED_BY_FIRST_NAME_PLACEHOLDER": "Voorbeeld : Jean",
    "AUTHORED_BY_LAST_NAME": "Naam van die outeur",
    "AUTHORED_BY_LAST_NAME_PLACEHOLDER": "Voorbeeld: Dupont",
    "AUTHORED_BY_MYSELF": "Ekself",
    "AUTHORED_BY_MY_SPACE": "My organisasie",
    "BUDGET": "Geskatte begroting",
    "BUDGET_PLACEHOLDER": "Gee die begroting aan",
    "CHOOSE_A_FOLDER": "Kies 'n vouer",
    "CONTENT": "Beskrywing",
    "CONTRIBUTION_KIND": {
      "CUSTOM_LABEL": "Bydraetipe",
      "CUSTOM_PLACEHOLDER": "Dui aan die tipe van bydraes wat u wil insamel.",
      "DESCRIPTION": "Pas die etiket van die knoppie (CTA) aan om bydraes in te dien.",
      "OPTIONS": {
        "CONTRIBUTION": "Bydrae",
        "OTHER": "Ander",
        "PROPOSAL": "Voorstel",
        "QUESTION": "Vraag",
        "REPORT": "Verslagdoening"
      },
      "PREVIEW": "Oorsig:",
      "TITLE": "Bydraetipe"
    },
    "DEFAULT_PROPOSAL_VIEW": {
      "OPTIONS": {
        "CAROUSEL": {
          "DESCRIPTION": "Om reaksies aan te moedig (stem vir of teen)",
          "NAME": "Karrousel"
        },
        "LIST": {
          "DESCRIPTION": "Vir 'n kompakte vertoning van al die bydraes",
          "NAME": "Lys"
        },
        "MAP": {
          "DESCRIPTION": "Vir 'n geografiese visualisering van die bydraes",
          "NAME": "Kaart"
        }
      },
      "SUBTITLE": "Verpersoonlik die bladsy van u konsultasie deur die verstekbeskouing van bydraes te kies. In alle gevalle sal gebruikers 'n ander beskouing kan kies.",
      "TITLE": "Vertoning van bydraes"
    },
    "DESCRIPTION": "Beskrywing",
    "DESCRIPTION_SECTION": {
      "DESCRIPTION": {
        "COMMUNICATION": "Hierdie afdeling laat jou toe om aan gebruikers die konteks en kwessies van jou nuus te verduidelik.",
        "CONSULTATION": "Hierdie afdeling stel u in staat om aan gebruikers die konteks en kwessies van u konsultasie te verduidelik.",
        "FOLDER": "Hierdie afdeling stel u in staat om die konteks en kwessies van u lêer aan gebruikers te verduidelik."
      },
      "TITLE": "Beskrywing van die benadering"
    },
    "DISPLAY_OPTIONS": {
      "CHILDREN_LIST_PICTURES": {
        "LABEL": "Wys die beelde van bydraes in die lys",
        "TITLE": "Beeld"
      },
      "COMMENTS_ENABLED": {
        "LABEL": "Aktiveer kommentaar onder u opname."
      },
      "GEOJSON": {
        "DESCRIPTION": "Pas die kaart aan met geografiese sones en belangrike punte op {link} en plak dan die kode hieronder.",
        "TITLE": "Pas die kaart aan"
      }
    },
    "EDIT": {
      "TITLE": {
        "ANOMALY": "Wysig die anomalie",
        "COMMUNICATION": "Wysig die nuusgebeurtenis",
        "CONSULTATION": "Wysig die konsultasie",
        "DEMAND": "Wysig die boodskap",
        "FOLDER": "Wysig die lêergids",
        "IDEA": "Wysig die bydrae"
      }
    },
    "EDITORS_FORM": {
      "DESCRIPTION": "Om toegang aan 'n gebruiker te gee, moet hy 'n <i>Bestuurder</i> van die ruimte wees. Slegs 'n <i>Administrateur</i> kan hierdie rol gee.",
      "SUBTITLE": "Die lys van gebruikers wat toegang het tot die bestuur van hierdie konsultasie.",
      "TITLE": "Bestuurders"
    },
    "END_AT": "Einddatum en -tyd",
    "ERRORS": {
      "FILL_FIELDS": "U moet die velde korrek invul.",
      "LOCATION_NOT_IN_THE_LIST": "U moet 'n adres uit die lys kies."
    },
    "EVENT_URL_LABEL": "Videokonferensie",
    "EVENT_URL_PLACEHOLDER": "Voeg die URL van 'n Zoom-, Jitsi-, Teams-, Meet-, ens. videokonferensie by.",
    "FORM_BUILDER": {
      "ACCEPTED_ANSWERS": "Toegestane Antwoord(e)",
      "ACCEPTED_ANSWERS_DATE_DESCRIPTION": "Bevestig die datum verskaf deur die gebruiker met 'n verwysingsdatum.",
      "ACCEPTED_ANSWERS_OPERATOR_LABEL": "Kies 'n operateur",
      "ACCEPTED_ANSWERS_QUESTION_OPTIONS_DESCRIPTION": "Kies elke moontlike antwoord.",
      "ACCEPTED_ANSWERS_SUMMARY": "Toegestane antwoorde",
      "ACCEPTED_ANSWERS_TEXT_DESCRIPTION": "Skei elke toegelate antwoord deur 'n reëlbreuk.",
      "ACCEPTED_ANSWERS_TEXT_PLACEHOLDER": "Antwoord 1  \nAntwoord 2  \nAntwoord 3  \nAntwoord 4",
      "ADD_DESCRIPTION": "Voeg 'n beskrywing by",
      "ADD_QUESTION": "Voeg 'n vraag by",
      "ADD_SECTION": "Voeg 'n afdeling by",
      "CONFIDENTIAL": "Vertroulik",
      "CONFIDENTIAL_INFORMATION_NOTICE": "Jou antwoord sal slegs sigbaar wees vir die administrateurs van die platform.",
      "CONFIDENTIAL_QUESTION": "Vertroulike vraag",
      "CONFIDENTIAL_QUESTION_DESCRIPTION": "Die antwoord sal slegs sigbaar wees vir die administrateurs en bestuurders met die regte.",
      "DATE_OPERATOR": {
        "EQ": "is",
        "GT": "is groter as",
        "GTE": "is groter of gelyk aan",
        "LT": "is minder as",
        "LTE": "is minder of gelyk aan",
        "NOT_EQ": "is nie"
      },
      "DEFAULT_FIELD_INFO": "Per verstek",
      "DESCRIPTION_LABEL": "Beskrywing",
      "DESCRIPTION_PLACEHOLDER": "Voorbeeld: Hierdie vraag sal ons help om jou beter te leer ken.",
      "DROPDOWN_QUESTION": "Keuselys",
      "DROPDOWN_QUESTION_DESCRIPTION": "Die opsies sal in 'n keuselys vertoon word.",
      "MAXLENGTH": "Beperk die aantal karakters",
      "MAXLENGTH_DESCRIPTION": "Verskaf die maksimum toegelate aantal karakters.",
      "MAXLENGTH_LABEL": "Aantal karakters",
      "MAXLENGTH_PLACEHOLDER": "Onbeperk",
      "MAXLENGTH_SUMMARY": "Maksimum karakters",
      "OPTIONS": {
        "ADD_OPTION": "Voeg 'n opsie by",
        "ADD_OTHER": "Voeg \"Ander\" by",
        "OR": "jy",
        "OTHER": "Ander"
      },
      "OPTION_LABEL": "Opsie {index}",
      "PLACEHOLDER": "Jou antwoord",
      "QUESTION_LINKS": {
        "DESCRIPTION": "Wys of die antwoord op ...",
        "OPERATOR": {
          "BLANK": "is leeg",
          "CONTAINS": "bevat",
          "EQ": "is",
          "GT": "is groter as",
          "GTE": "is groter as of gelyk aan",
          "LT": "is minder as",
          "LTE": "is kleiner as of gelyk aan",
          "NOT_CONTAINS": "bevat nie",
          "NOT_EQ": "is nie",
          "PRESENT": "is nie leeg nie"
        },
        "OPERATOR_LABEL": "Operateur",
        "OPTIONS_LABEL": "Opsiesies",
        "QUESTION_LABEL": "Vraag",
        "TITLE": "Vraag vertoon"
      },
      "QUESTION_LINKS_SUMMARY": "Vertoonvoorwaarde",
      "REQUIRED": "Verpligtend",
      "REQUIRED_QUESTION": "Verpligte vraag",
      "SUBMIT_FORM": "Dien die vorm in",
      "SURVEY_DESCRIPTION_1": "Die vraelys stem ooreen met die vrae wat u aan u gebruikers wil stel.",
      "SURVEY_DESCRIPTION_2": "Stel die vraelys in volgens u konsultasie.",
      "SURVEY_TITLE": "Vraelys",
      "TITLE_LABEL": "Vraag",
      "TITLE_PLACEHOLDER": "Voorbeeld: Wat is u ouderdom?",
      "TYPES": {
        "ATTACHMENT": "Aangehegte lêers",
        "CHECKBOX": "Meervoudige antwoorde",
        "DATE": "Datum",
        "LOCATION": "Lokalisering",
        "MONEY": "Begroting",
        "PHONE_NUMBER": "Telefoonnommer",
        "PICTURE": "Omslagbeeld",
        "RADIO": "Enkele antwoord",
        "SECTION": "Afdeling",
        "TEXT": "Kort antwoord",
        "TEXTAREA": "Paragraaf",
        "TITLE": "Tipe veld"
      },
      "TYPE_SELECT_WARNING": {
        "DESCRIPTION_1": "Jy het reeds antwoorde vir hierdie vraag ingesamel.",
        "DESCRIPTION_2": "As u dit verander, sal die geassosieerde antwoorde permanent uitgevee word.",
        "DESCRIPTION_3": "Het jy hierdie data nodig? Voer jou antwoorde uit voordat jy hierdie vraag en/of opsie verwyder.",
        "TITLE": "Is jy seker?"
      }
    },
    "GENERAL_INFO": "Algemene inligting",
    "IMAGE": "Beeld",
    "LOCALISATION_LABEL": "Plek of adres",
    "LOCALISATION_MARKER_PLACED": "Merker geplaas",
    "LOCALISATION_MODAL_NEGATIVE_BUTTON": "Verwyder",
    "LOCALISATION_MODAL_NOTICE_TEXT": "Klik op die kaart om die merker te plaas.",
    "LOCALISATION_MODAL_POSITIVE_BUTTON": "Bevestig",
    "LOCALISATION_MODAL_TITLE": "Voeg 'n ligging by",
    "LOCALISATION_NO_RESULTS": "Tik asseblief om voorstelle te kry",
    "LOCALISATION_PLACEHOLDER": "Voeg 'n ligging by",
    "LOCALISATION_SEE_MAP": "Sien die kaart",
    "MODERATABLE": {
      "LABEL": "Matiging voor publikasie",
      "TOOLTIP": "Alle bydraes moet deur 'n administrateur gevalideer word voordat hulle gepubliseer en sigbaar vir ander gebruikers is."
    },
    "NEW": {
      "ANOMALIES": {
        "DESCRIPTION_PLACEHOLDER": "Stel 'n beskrywing op wat die spesifieke afwyking en sy aard uiteensit. Gee konteks om die hantering daarvan te vergemaklik.",
        "MODAL_DESCRIPTION": "{spaceName} sal jou so gou moontlik antwoord.",
        "MODAL_TITLE": "Veels geluk, die anomalie is gestuur!",
        "SIDEBAR_ACTION": "Stuur",
        "SIDEBAR_DESCRIPTION": "Die organisasie luister na u en sal u so gou moontlik antwoord.",
        "TITLE": "Meld 'n afwyking aan",
        "TITLE_PLACEHOLDER": "Ek wil graag aanmeld…"
      },
      "ARTICLES": {
        "DESCRIPTION_PLACEHOLDER": "Bied 'n aktuele onderwerp aan of beklemtoon 'n inisiatief, om gereeld oor die nuwe maatreëls in te lig en opvoedkundige inligting te versprei.",
        "MODAL_DESCRIPTION": "Dit is nou sigbaar vir die ander gebruikers van hierdie ruimte. {isPrivateSpace, select, true {} other {Deel dit op sosiale media om dit nog meer sigbaarheid te gee.}}",
        "MODAL_TITLE": "Baie geluk, die artikel is gepubliseer!",
        "PROBLEMATIC_PLACEHOLDER": "Beskryf u artikel in een sin om lesers lus te maak om dit te lees.",
        "TITLE": "Skep 'n artikel",
        "TITLE_PLACEHOLDER": "Skryf 'n titel wat gebruikers se belangstelling wek."
      },
      "COLLABORATIVE_DECISIONS": {
        "DESCRIPTION_PLACEHOLDER": "Verskaf besonderhede oor die konteks van hierdie beraadslaging. Verduidelik die deelnamevoorwaardes sodat gebruikers op 'n relevante manier kan deelneem aan die soek na oplossings.",
        "MODAL_DESCRIPTION": "Dit is nou sigbaar vir ander gebruikers. Maak dit op jou tuisblad vas deur dit uit te lig vir nog meer sigbaarheid.",
        "MODAL_TITLE": "Baie geluk, die konsultasie is gepubliseer!",
        "PROBLEMATIC_PLACEHOLDER": "Moedig gebruikers aan om deel te neem met 'n kort sin.",
        "SIDEBAR_ACTION": "Publiseer",
        "TITLE": "Skep 'n oorlegvoering",
        "TITLE_PLACEHOLDER": "Skryf 'n titel wat gebruikers se belangstelling wek."
      },
      "DEMANDS": {
        "DESCRIPTION_PLACEHOLDER": "Verduidelik die konteks van die boodskap deur enige element aan te dui wat kan help om jou onderwerp beter te verstaan.",
        "MODAL_CTA": "Sien my boodskappe",
        "MODAL_DESCRIPTION": "Die ontvanger sal binne die kortste tyd 'n kennisgewing ontvang. U kan enige tyd hierdie boodskap in die \"My boodskappe & afwykings\" spyskaart van u profiel vind.",
        "MODAL_TITLE": "Baie geluk, die boodskap is gestuur!",
        "SIDEBAR_ACTION": "Stuur",
        "SIDEBAR_DESCRIPTION": "Hierdie inhoud is vertroulik. Slegs die gebruiker en die administrateurs kan dit besigtig.",
        "TITLE": "Stuur 'n boodskap",
        "TITLE_PLACEHOLDER": "Ek wil graag inligting oor..."
      },
      "EVENTS": {
        "CONFIGURATION": {
          "DESCRIPTION": "Hierdie afdeling stel jou in staat om die datum en plek (adres en/of skakel na 'n videokonferensie) van die gebeurtenis aan gebruikers te spesifiseer.",
          "TITLE": "Deelnamevoorwaardes"
        },
        "DESCRIPTION_PLACEHOLDER": "Stel die konteks van die geleentheid voor en lig die gebruikers in oor die voorwaardes om daarheen te gaan.",
        "MODAL_DESCRIPTION": "Dit is nou sigbaar vir ander gebruikers. Deel dit op sosiale media om dit nog meer sigbaarheid te gee.",
        "MODAL_TITLE": "Baie geluk, die gebeurtenis is gepubliseer!",
        "PROBLEMATIC_PLACEHOLDER": "Beskryf jou geleentheid in een sin om mense aan te moedig om dit te lees.",
        "SIDEBAR_ACTION": "Publiseer",
        "TITLE_PLACEHOLDER": "Skryf 'n titel wat die belangstelling van gebruikers wek."
      },
      "FOLDERS": {
        "DESCRIPTION_PLACEHOLDER": "Gee vir besonderhede oor die konteks van hierdie lêer. Verduidelik die deelnamevoorwaardes sodat gebruikers op 'n gepaste wyse kan deelneem aan die soeke na oplossings.",
        "MODAL_DESCRIPTION": "Dit is nou sigbaar vir ander gebruikers. Speld dit op jou tuisblad deur dit uit te lig vir nog meer sigbaarheid.",
        "MODAL_TITLE": "Veels geluk, die lêer is gepubliseer!",
        "PROBLEMATIC_PLACEHOLDER": "Voeg 'n inspirerende frase oor jou lêer by.",
        "SIDEBAR_ACTION": "Publiseer",
        "TITLE_PLACEHOLDER": "Skryf 'n titel wat gebruikers se belangstelling wek."
      },
      "IDEAS": {
        "DESCRIPTION_PLACEHOLDER": "Verduidelik u bydrae en hoe dit werk.",
        "MODAL_CTA": "Sien my bydraes",
        "MODAL_DESCRIPTION": "Vind al jou bydraes in jou profiel.",
        "MODAL_DESCRIPTION_GUEST": "Om die vordering te volg en opdaterings te ontvang, skep 'n rekening. Sonder registrasie sal jy nie meer die impak kan sien of kennisgewings oor stemme en kommentaar kan ontvang nie.",
        "MODAL_TITLE": "Dankie vir u deelname",
        "REDIRECT": "Hierdie skakel lyk of dit nie werk nie. Vind die konsultasie in die lys om 'n bydrae te kan lewer.",
        "TITLE": "Vul die vorm in",
        "TITLE_PLACEHOLDER": "Ons kan...",
        "WITHOUT_MODERATION": {
          "SIDEBAR_ACTION": "Publiseer",
          "SIDEBAR_DESCRIPTION": "Sodra dit gepubliseer is, sal ander gebruikers jou bydrae kan verryk deur voorstelle te maak."
        },
        "WITH_MODERATION": {
          "SIDEBAR_ACTION": "Indien",
          "SIDEBAR_DESCRIPTION": "Die bydrae sal gepubliseer word sodra dit deur die dienste goedgekeur is."
        }
      },
      "IDEAS_REQUESTS": {
        "DESCRIPTION_PLACEHOLDER": "Verskaf besonderhede oor die konteks van hierdie versoek om bydraes. Verduidelik die deelnamevoorwaardes sodat gebruikers op 'n relevante manier aan die soeke na oplossings kan deelneem.",
        "MODAL_DESCRIPTION": "Dit is nou sigbaar vir ander gebruikers. Maak dit op jou tuisblad vas deur dit uit te lig vir nog meer sigbaarheid.",
        "MODAL_TITLE": "Veels geluk, die oproep vir bydraes is gepubliseer!",
        "PROBLEMATIC_PLACEHOLDER": "Moedig gebruikers aan om deel te neem met 'n enkele sin.",
        "SIDEBAR_ACTION": "Publiseer",
        "TITLE_PLACEHOLDER": "Skryf 'n titel wat gebruikers se belangstelling wek."
      },
      "PARTICIPATORY_BUDGETS": {
        "DESCRIPTION_PLACEHOLDER": "Verskaf besonderhede oor die konteks van hierdie deelnemende begroting. Verduidelik die deelname-modaliteite sodat gebruikers op 'n relevante manier aan die soeke na oplossings kan deelneem.",
        "MODAL_DESCRIPTION": "Dit is nou sigbaar vir ander gebruikers. Speld dit op jou tuisblad deur dit uit te lig vir nog meer sigbaarheid.",
        "MODAL_TITLE": "Veels geluk, die deelnemende begroting is gepubliseer!",
        "PROBLEMATIC_PLACEHOLDER": "Maak gebruikers lus om deel te neem in een sin.",
        "SIDEBAR_ACTION": "Publiseer",
        "TITLE_PLACEHOLDER": "Skryf 'n titel wat die gebruikers se belangstelling wek."
      },
      "STUDIES": {
        "DESCRIPTION": "Die opname stem ooreen met die vorm wat buite die platform op Typeform, Google Form, Survey Monkey, Tally of enige ander platform geskep is wat toelaat dat vorms geskep word.",
        "DESCRIPTION_PLACEHOLDER": "Verskaf besonderhede oor die konteks van hierdie konsultasie sowel as die modaliteite van deelname daaraan.",
        "FORM_DESCRIPTION": "Voeg die skakels van jou opname by om dit op jou platform te deel.",
        "MODAL_DESCRIPTION": "Dit is nou sigbaar vir ander gebruikers. Deel dit op sosiale media om nog meer sigbaarheid te gee.",
        "MODAL_TITLE": "Baie geluk, die opname is gepubliseer!",
        "PROBLEMATIC_PLACEHOLDER": "Moedig gebruikers aan om deel te neem met net een sin.",
        "SIDEBAR_ACTION": "Publiseer",
        "STUDY_ID_PLACEHOLDER": "Eksemplaar: https://fluicity.typeform.com/to/A1b2C3d4",
        "STUDY_RESULT_PLACEHOLDER": "Voorbeeld : https://fluicity.typeform.com/report/A1b2C3d4/E5f6G7h8",
        "STUDY_RESULT_TITLE": "Skakel na resultate",
        "STUDY_TITLE": "Skakel van die opname",
        "TITLE_PLACEHOLDER": "Skryf 'n titel wat die belangstelling van gebruikers wek."
      },
      "TITLE": {
        "ANOMALY": "Skep 'n afwyking",
        "COMMUNICATION": "Skep 'n nuusberig",
        "CONSULTATION": "Skep 'n konsultasie",
        "DEMAND": "Skep 'n boodskap",
        "FOLDER": "Skep 'n gids",
        "IDEA": "Skep 'n bydrae"
      }
    },
    "POST_PUBLISHED": "Hierdie inhoud is nou gepubliseer.",
    "POST_PUBLISHED_AT": "Gepubliseer op {date} om {time}",
    "POST_SAVED": "Die wysigings is gestoor.",
    "POST_SCHEDULED": "Hierdie inhoud is geskeduleer vir {date} om {time}",
    "PROBLEMATIC": "Aantrekkingskrag",
    "PUBLICATION_CANCELLED": "Die publikasie is suksesvol gekanselleer.",
    "SIMILAR_PROPOSALS": "Ander gebruikers blyk te wees dat hulle soortgelyke bydraes gedeel het:",
    "START_AT": "Aanvangsdatum en -tyd",
    "STEPS": {
      "CONFIGURATION": "Fasekonfigurasie",
      "DESCRIPTION": "Hierdie afdeling stel u in staat om belangrike datums van die konsultasie aan gebruikers deur te gee.",
      "DESCRIPTION_TABS": "Oortjies van die meertalige beskrywing van die fase",
      "END_AT_HELPER_TEXT": "Opsioneel vir deurlopende stappe",
      "IMPLEMENTATION": {
        "ADMIN_ONLY_PLACEHOLDER": "Dink daaraan om die \"Skakel van resultate\" by te voeg en die konfigurasie na te gaan om die opsie te aktiveer.",
        "ADMIN_ONLY_TEXT": "Wys die resultate van die konsultasie",
        "SURVEYS": {
          "ADMIN_ONLY_PLACEHOLDER": "Die volledige verslag bied al die resultate van die opname aan, vraag vir vraag. Dit is 'n belangrike element van deursigtigheid ten opsigte van die gebruikers.",
          "ADMIN_ONLY_TEXT": "Toon die resultate van die konsultasie"
        }
      },
      "PLACEHOLDER": "Verduidelik die verloop van hierdie stap.",
      "SUBMISSION": {
        "ADMIN_ONLY_PLACEHOLDER": "Alle gebruikers kan bydraes in die konsultasie publiseer. As die opsie gedeaktiveer is, sal slegs die administrateurs nuwe bydraes kan skep.",
        "ADMIN_ONLY_TEXT": "Bewaarplek oop vir gebruikers"
      },
      "TITLE": "Opstelling van die verloop"
    },
    "TITLE": "Titel",
    "UNDERSTOOD": "Verstaan!",
    "VIDEO": "Video",
    "VIDEO_HELPER": "Jy kan slegs 'n Youtube- of Vimeo-video deel.",
    "VIDEO_LABEL": "Skakel na 'n video",
    "VIDEO_PLACEHOLDER": "Voorbeeld: http://www.youtube.com/watch?=id of http://vimeo.com/id",
    "VOTING_OPTIONS": {
      "BUDGET_RULE": {
        "LABEL": "Beperk die stemme (Vir) tot die voorafbepaalde begroting van {count}",
        "TITLE": "Begrotingsbeperking"
      },
      "MIN_MAX": {
        "MAX_LABEL": "Maksimum aantal stemme",
        "MIN_LABEL": "Minimum aantal stemme",
        "TITLE": "Aantal toegewezen ondersteuningspanne"
      },
      "TYPE": {
        "BUDGET": {
          "DESCRIPTION": "Gebruikers sal bydraes kan ondersteun tot die totale begroting uitgeput is. Bydraes moet begroot word.",
          "NAME": "Per koevert"
        },
        "DOUBLE": {
          "DESCRIPTION": "Gebruikers sal bydraes positief of negatief kan ondersteun. Dit word dikwels gebruik in die geval van 'n oproep tot bydraes of reaksies.",
          "NAME": "Vir of Teen"
        },
        "SINGLE": {
          "DESCRIPTION": "Gebruikers sal slegs op 'n positiewe wyse bydraes kan ondersteun. Hierdie module word dikwels gebruik as u konsultasie 'n stemfase insluit.",
          "NAME": "Giet"
        },
        "SUBTITLE_1": "Die stemmodaliteite laat gebruikers toe om die bydraes wat in jou konsultasie gemaak is, te ondersteun.",
        "SUBTITLE_2": "Stel die bepalings in volgens u projek",
        "TITLE": "Stembriewe"
      },
      "UNLIMITED": "Onbeperk"
    }
  },
  "POST_STEPS_TYPES": {
    "DEFAULT": {
      "ANALYSIS": "Ontleding",
      "CONTRIBUTION": "Bydrae",
      "IMPLEMENTATION": "Resultate",
      "SUBMISSION": "Belegging",
      "VOTE": "Stem"
    },
    "STUDY": {
      "IMPLEMENTATION": "Resultate",
      "SUBMISSION": "Antwoord"
    }
  },
  "PREVIOUS": "Vorige",
  "PROFILE": {
    "ADDRESS": "Gemeente",
    "BIRTHDATE": "Geboortedatum",
    "CROSS_SPACES_WARNING": "Die onderstaande inligting het betrekking op al die ruimtes waaraan jy aangesluit het.",
    "FIRST_NAME": "Voornaam",
    "LAST_NAME": "Naam",
    "NAME_IS_PRIVATE": "Die ander gebruikers sal jou sien as: {displayName}",
    "NATIONAL_ID": "Nasionale registrasienommer",
    "PRIVATE_INFORMATION_NOTICE": "Hierdie inligting sal slegs vir statistiese doeleindes in verband met deelname gebruik word.",
    "PROFILE_UPDATED": "Profiel opgedateer.",
    "SEX": "Geslag",
    "SEX_FEMALE": "Vrou",
    "SEX_HELPER": "Soos aangedui op u nasionale identiteitsdokument. Hierdie data, wanneer saamgevoeg, word vergelyk met die statistieke wat deur nasionale instellings of deur die organisme self verskaf word.",
    "SEX_MALE": "Man",
    "SEX_UNSPECIFIED": "Nie gespesifiseer nie",
    "SOCIOPROFESSIONAL_CATEGORY": "Sosio-professionele kategorie",
    "TITLE": "My rekening"
  },
  "PUBLISHING_POST_DIALOG": {
    "NO_QUESTIONS_WARNING": "Voordat u hierdie inhoud kan publiseer, moet u {link} aan die vorm.",
    "NO_QUESTIONS_WARNING_LINK_TEXT": "voeg vrae by",
    "PARENT_WARNING": "Voordat jy hierdie inhoud kan publiseer, moet jy {link} publiseer.",
    "PUBLISH": {
      "BUTTON": "Publiseer nou",
      "CONTENT": "Wil jy regtig publiseer?",
      "NO": "Nee",
      "TOAST": "Hierdie inhoud is gepubliseer.",
      "YES": "Ja, publiseer"
    },
    "SCHEDULE": {
      "BUTTON": "Beplan die publikasie",
      "CONTENT": "Wil u regtig beplan?",
      "NO": "Nee",
      "TOAST": "Hierdie inhoud is beplan.",
      "YES": "Ja, beplan"
    },
    "UNPUBLISH": {
      "BUTTON": "Depubliseer",
      "CHILDREN_WARNING": "As jy hierdie inhoud afpubliseer, sal alles wat dit bevat ook afpubliseer ({childrenCount}).",
      "CONTENT": "Wil jy regtig depubliseer?",
      "NO": "Nee",
      "TOAST": "Hierdie inhoud is gedepubliseer.",
      "YES": "Ja, depubliseer"
    },
    "UNSCHEDULE": {
      "BUTTON": "Kanselleer die beplanning",
      "CONTENT": "Is jy regtig seker jy wil die beplanning kanselleer?",
      "NO": "Nie",
      "TOAST": "Die beplanning van hierdie inhoud is gekanselleer.",
      "YES": "Ja, kanselleer die beplanning"
    }
  },
  "QUESTIONS": {
    "RESULTS": {
      "ANSWERS_COUNT": "{count, plural, =0 {Geen antwoorde} one {{count} antwoord} other {{count} antwoorde}}"
    }
  },
  "SEARCH": {
    "BUTTON": "Soek",
    "CATEGORIES_PLACEHOLDER": "Filter volgens tema",
    "EMPTY_SEARCH": {
      "NEW_SEARCH": "Begin om sleutelwoorde in die soekbalk in te tik.",
      "NO_RESULTS": "Kyk of jy alles reg gespel het. Jy kan ook probeer om jou soektog te verkort of te herformuleer."
    },
    "INPUT_PLACEHOLDER": "Soek",
    "RESULTS_COUNT": "{count, plural, =0 {Geen resultate} one {{count} resultaat} other {{count} resultate}}",
    "TYPES_PLACEHOLDER": "Filtreer volgens inhoud tipe"
  },
  "SECURED_STRATEGIES": {
    "BACK_TO_POST": "Terug na die konsultasie",
    "BIRTHDATE": {
      "TITLE": "Geboortedatum"
    },
    "CSAM": {
      "TITLE": "Verbinding via CSAM"
    },
    "CTA": "Deelnemen",
    "DESCRIPTION": "<b>Hierdie konsultasie is beveilig.</b> Om toegang daartoe te verkry, moet u die gegewens hieronder gelys valideer en die ontbrekende invul.<conditional> Op enige tydstip kan u u regte op toegang, regstelling en verwydering van hierdie gegewens uitoefen deur dpo@flui.city te kontak.</conditional>",
    "DIMENSIONS": {
      "ERROR": "Ongelukkig laat die inligting wat u gespesifiseer het, u nie toe om aan die konsultasie deel te neem nie. Korrigeer u data of keer terug na die konsultasie.",
      "TITLE": "Afmetings"
    },
    "INLINE_DESCRIPTION": "<b>Hierdie konsultasie is beveilig.</b> Om toegang te verkry, moet u die nodige data verskaf. U kan te eniger tyd u regte van toegang, regstelling en uitwissing van hierdie data uitoefen via die profielbladsy as u 'n rekening het, of per e-pos via dpo@flui.city.",
    "NATIONAL_ID": {
      "ERROR": "U moet 'n geldige registrasienommer met 11 syfers invoer.",
      "TITLE": "Nasionale registrasienommer"
    },
    "PENDING_VERIFICATION_TOOLTIP": "Jou deelname sal eers oorweeg word <b>na verifikasie van jou dokumente</b>.",
    "PREVENT_GO_IDENTITY": {
      "BACK": "Agterkant (slegs nuwe identiteitskaart)",
      "FORM": {
        "DESCRIPTION": "Verskaf asseblief die voorkant en agterkant van jou identiteitsdokument (JPEG, JPG, PNG, HEIC, WEBP of PDF formaat, maksimum aanbevole grootte 2MB).<br></br>Slegs die volgende word aanvaar:<ul><li>Nasionale identiteitskaart</li><li>Franse paspoort</li><li>Rybewys (nuwe kredietkaartformaat)</li></ul>",
        "GENERIC_ERROR": "'n Fout het voorgekom tydens die aflaai van u dokumente. Kontroleer asseblief die status van u verbinding of probeer later weer. U kan ook probeer deur die grootte van die dokument te verminder (maksimum aanbevole grootte 2MB).",
        "SUCCESS_TOAST": "Jou identiteit is suksesvol geverifieer."
      },
      "FRONT": "Voorblad",
      "NO": "Geen",
      "TITLE": "Identiteitsdokument",
      "YES": "Ja"
    },
    "PROOF_OF_RESIDENCY": {
      "ACCEPTED_DOCUMENTS": "Slegs die volgende word aanvaar: <ul><li>Onlangse elektrisiteits-, gas- of waterrekening</li><li>Vaste of mobiele telefoonrekening</li><li>Salarisstrokie</li><li>Versekeringsertifikaat vir woonstelle (brand, huurrisiko's of burgerlike aanspreeklikheid)</li><li>Stemkaart</li><li>Belastingkennisgewing</li></ul>",
      "BUTTON_DISABLED_TOOLTIP": "U moet eers u identiteitsdokument valideer om u bewys van adres te stuur.",
      "DESCRIPTION": "Verskaf asseblief 'n bewys van verblyf (JPEG, JPG, PNG, HEIC, WEBP of PDF-formaat, maksimum aanbevole grootte 2MB).",
      "DOCUMENT_CONFIRMATION": "Na verifikasie deur ons spanne, sal 'n e-pos aan u gestuur word om u deelname te bevestig.",
      "TITLE": "Bewys van adres"
    },
    "QUESTIONS": {
      "INCORRECT_VALUE": "Hierdie waarde is verkeerd."
    },
    "SIGNUP_INVITATION": "Asseblief, skep 'n rekening as jy 'n <b>bevestigings-e-pos wil ontvang</b> van jou deelname en jou dokumente wil stoor.",
    "SUCCESS": "U kan nou aan die konsultasie deelneem.",
    "TOOLTIP": "Hierdie konsultasie is beveilig en vereis sekere inligting om daaraan deel te neem.",
    "VALIDATED_INLINE_DESCRIPTION": "Ons het u identiteit bevestig as <b>{fullName}</b>.",
    "VERIFIED_EMAIL": {
      "TITLE": "Rekeningverifikasie"
    }
  },
  "SECURITY": {
    "DISPLAY_SECURED_STRATEGY_QUESTIONS": "Wys sekuriteitsvrae",
    "FORM_BUILDER": {
      "DESCRIPTION": "Sekuriteitsvrae is toegangsbeheermeganismes.<br></br> Hulle laat toe om te verifieer dat deelnemers aan sekere voorwaardes voldoen voordat hulle kan bydra, stem, kommentaar lewer of 'n opname beantwoord (byvoorbeeld: toegangskode, nasionale ID, inwoner van 'n gebied, ens.).",
      "TITLE": "Veiligheidsvrae"
    },
    "OPTION_1": {
      "DESCRIPTION": "Geen registrasie is nodig om deel te neem nie.",
      "TITLE": "Almal"
    },
    "OPTION_2": {
      "DESCRIPTION": "Gebruikers moet registreer om deel te neem.",
      "TITLE": "Geregistreerdes"
    },
    "OPTION_3": {
      "DESCRIPTION": "Gebruikers moet hul rekening verifieer om deel te neem.",
      "TITLE": "Geverifieerde gebruikers"
    },
    "OPTION_4": {
      "DESCRIPTION": "Die berging is gesluit vir gebruikers.",
      "TITLE": "Administrateurs"
    },
    "WHO_CAN_COMMENT": "Wie kan kommentaar lewer?",
    "WHO_CAN_RESPOND_SURVEY": "Wie kan die opname beantwoord?",
    "WHO_CAN_SUBMIT_CONTRIBUTION": "Wie kan 'n bydrae lewer?",
    "WHO_CAN_VOTE": "Wie mag stem?"
  },
  "SETTINGS": {
    "ACCOUNT": {
      "CONNECTION_SETTINGS": "Aanmeldinstellings",
      "DATA_SHARED_WITH_SPACE": "My data",
      "LANGUAGE": "Taal",
      "PASSWORD": "Wagwoord (minimum 12 karakters)",
      "VERIFIED": "Geverifieer",
      "VERIFIED_EMAIL": "E-pos bevestig"
    },
    "COOKIES": {
      "DESCRIPTION": "Die volgende \"funksionele\" koekies stel spesifieke en opsionele funksies op Fluicity Engage in staat om jou gebruikerservaring te verbeter.",
      "FACEBOOK": {
        "DESCRIPTION": "Laat jou toe om aan te meld by jou deelname ruimte met behulp van jou Facebook-rekening.",
        "TITLE": "Facebook Koppel"
      },
      "GOOGLE": {
        "DESCRIPTION": "Dit stel jou in staat om aan te meld by jou deelnemingsruimte deur jou Google-rekening te gebruik.",
        "TITLE": "Google-aanmelding"
      },
      "TITLE": "My koekievoorkeure",
      "VIMEO": {
        "DESCRIPTION": "Dit stel jou in staat om video's wat op Vimeo gehuisves word direk vanaf jou deelnemer-ruimte te besigtig.",
        "TITLE": "Vimeo"
      },
      "YOUTUBE": {
        "DESCRIPTION": "Dit stel jou in staat om video's wat op Youtube gehuisves word, direk vanaf jou deelnemingsruimte te kyk.",
        "TITLE": "YouTube"
      }
    },
    "DESTROY_ACCOUNT": {
      "CONFIRM": "Ja, verwyder my rekening",
      "CTA": "Verwyder my rekening",
      "TITLE": "Is jy seker dat jy jou Fluicity Engage-rekening wil uitvee?"
    },
    "EMAIL_SUBSCRIPTION": {
      "UNSUBSCRIBE": {
        "SUCCESS_DESCRIPTION": "Om u uit te teken of weer in te teken op een of meer tipes kennisgewings, kan u u instellings hieronder verander. Hierdie instellings is ook te alle tye vanaf u rekening se instellings toeganklik.",
        "SUCCESS_TITLE": "Jou versoek om uit te teken is suksesvol ontvang."
      }
    },
    "JOIN_SPACE": "Sluit aan by {spaceName}",
    "LANGUAGE": {
      "LABEL": "Taal"
    },
    "LEAVE_SPACE": {
      "CONFIRM": "Ja, verlaat die ruimte",
      "CTA": "Verlaat {spaceName}",
      "DESCRIPTION": "As jy hierdie ruimte verlaat, sal jy nie meer kennisgewings ontvang wat verband hou met konsultasies of nuus nie en sal jy nie meer nuwe bydraes kan lewer, kommentaar lewer, stem, ensovoorts nie.",
      "TITLE": "Is jy seker jy wil {spaceName} verlaat?"
    },
    "NO_SPACES": "Jy volg geen ruimtes nie.",
    "PASSWORD": {
      "CONFIRMATION": "Bevestiging wagwoord",
      "CREATE": "Skep",
      "CREATE_INPUT": "Skep 'n wagwoord",
      "CREATE_MESSAGE": "Jy het nog nie 'n wagwoord opgestel nie.",
      "CURRENT": "Huidige wagwoord",
      "DIALOG": {
        "CREATE_TITLE": "Skep 'n wagwoord",
        "SUBTITLE_2": "Dankie dat u u huidige wagwoord en u nuwe wagwoord invoer:",
        "TITLE": "Verander my wagwoord",
        "VALIDATE": "Bevestig"
      },
      "ERROR_LOGIN": "Konneksiefout.",
      "FORGOT_PASSWORD": "Wagwoord vergeet?",
      "NEW": "Nuwe wagwoord",
      "PLACEHOLDER": "Wagwoord",
      "SHORT_PASSWORD": "Die wagwoordgrootte kan nie minder as {length} karakters wees nie.",
      "SUCCESS": "Die nuwe wagwoord is gestoor.",
      "UPDATE": "Wysig",
      "WRONG_PASSWORD": "Die wagwoord moet 'n minimum van 8 karakters wees."
    },
    "PERSONAL_DATA": {
      "REQUEST_PERSONAL_DATA": {
        "BUTTON": "Dien 'n versoek in vir die oordraagbaarheid van my persoonlike data.",
        "EMAIL_BODY": "Goeie dag,\n\nIn ooreenstemming met die Privaatheidsbeleid van die Fluicity Engage-oplossing, wil ek graag 'n uitvoer hê van al die persoonlike data wat my betref en op die platform geberg word.\n\nMy e-posidentifiseerder op die platform is: {userEmail}\n\nBaie dankie vooraf,\n\n{userName}",
        "EMAIL_SUBJECT": "Versoek om oordraagbaarheid van my data"
      },
      "TITLE": "Privaatheid en persoonlike data"
    },
    "REQUIRED_DIMENSION_INFO": "Sommige inligting is nodig vir deelname aan hierdie ruimte. Om jou regte tot uitwissing uit te oefen, hoef jy net die ruimte te verlaat.",
    "SPACE_SELECTION": "Keuse van ruimte",
    "TABS": {
      "INFO": "My Inligting",
      "MY_SPACE": "My ruimte",
      "NOTIFICATIONS": "My kennisgewings",
      "SETTINGS": "My instellings"
    }
  },
  "SIGN_IN": "Aansluit",
  "SIGN_OUT": "Aantekeninge uit",
  "SIGN_UP": {
    "EMAIL": "E-pos",
    "LOCATION_LABEL": "Woonbuurt",
    "LOCATION_PLACEHOLDER": "Voorbeeld: Parys",
    "PRIVACY": "Privaatheidsbeleid",
    "TERMS": "Gebruiksvoorwaardes"
  },
  "SORT": {
    "COMMENTED": "Die mees gekommenteerdes",
    "LEAST_EXPENSIVE": "Die goedkoopste",
    "POPULAR": "Gewild",
    "RANDOM": "Willekeurig",
    "RECENT": "Die nuutste",
    "UPVOTED": "Die mees gestemde"
  },
  "SPACE": {
    "ABOUT": {
      "STATS": {
        "CONSULTATIONS_COUNT": "{count, plural, =0 {konsultasie begin} one {konsultasie begin} other {konsultasies begin}}",
        "IDEAS_DONE_COUNT": "{count, plural, =0 {bydrae verwesenlik} one {bydrae verwesenlik} other {bydraes verwesenlik}}",
        "PARTICIPATIONS_COUNT": "{count, plural, =0 {deelname} one {deelname} other {deelname}}",
        "SUBSCRIBED_CITIZENS": "{count, plural, =0 {ingeskryf} one {ingeskryf} other {ingeskrewe}}"
      },
      "TITLE": "Algemeen"
    },
    "CONSULTATIONS": {
      "EMPTY_STATE": "Hier sal u die lêers, bydrae-oproepe, deelnemende begrotings en opnames vind wat deur die organisasie gepubliseer is.",
      "TITLE": "{count, plural, =0 {Geen konsultasie} one {{count} konsultasie} other {{count} konsultasies}}"
    },
    "CONTRIBUTIONS": {
      "MESSAGING": {
        "EMPTY_STATE": "U sal hier u boodskappe en afwykings vind.",
        "TITLE": "My boodskappe & afwykings"
      },
      "PROPOSALS": {
        "EMPTY_STATE": "Hier sal jy jou bydraes vind.",
        "TITLE": "My bydraes"
      }
    },
    "FORM": {
      "ADDRESS_LABEL": "Adresse",
      "ADDRESS_PLACEHOLDER": "Soek 'n adres",
      "ADMINISTRATORS": "Administrateurs",
      "BRAND_LOGO_LABEL": "Logo van jou ruimte",
      "BRAND_LOGO_TOOLTIP": "Die logo van die ruimte sal links bo op die bladsy in die navigasiebalk en in die e-posse vertoon word.",
      "COLOR_LABEL": "Kleur",
      "COLOR_PLACEHOLDER": "Kleur",
      "DECISION_MAKER_FIRST_NAME_LABEL": "Voornaam van borg",
      "DECISION_MAKER_FIRST_NAME_PLACEHOLDER": "Voer die voornaam in",
      "DECISION_MAKER_LAST_NAME_LABEL": "Borg se naam",
      "DECISION_MAKER_LAST_NAME_PLACEHOLDER": "Voer die naam in",
      "DECISION_MAKER_PICTURE_LABEL": "Borg se profielprent",
      "DECISION_MAKER_ROLE_LABEL": "Borg se rol",
      "DECISION_MAKER_ROLE_PLACEHOLDER": "Spesifiseer die missie van die borg in u organisasie",
      "DESCRIPTION_HELPER": "Die meta beskrywing tag laat soekenjins toe om 'n oorsig van die inhoud van bladsye te kry wat tydens 'n soektog vertoon word.",
      "DESCRIPTION_LABEL": "Meta beskrywing",
      "DESCRIPTION_PLACEHOLDER": "Skryf 'n kort en boeiende lokteks",
      "EMAIL_LABEL": "E-pos",
      "EMAIL_PLACEHOLDER": "email@monsite.com",
      "FACEBOOK_URL_LABEL": "Facebook",
      "FACEBOOK_URL_PLACEHOLDER": "https://www.facebook.com/mynblad",
      "FAVICON_LABEL": "Favicon",
      "FAVICON_TOOLTIP": "Die favicon is die ikoon wat in die blaaier se oortjies verskyn om u webwerf makliker te identifiseer.",
      "INSTAGRAM_URL_LABEL": "Instagram",
      "INSTAGRAM_URL_PLACEHOLDER": "https://www.instagram.com/mybladsy",
      "LEGAL_NOTICE": {
        "COMPANY_ADDRESS": "Straatadres: 210 avenue Jean Jaurès, 69007 Lyon, Frankryk",
        "COMPANY_EMAIL": "E-pos : info@flui.city",
        "COMPANY_NAME": "Fluicity",
        "COMPANY_PHONE": "Telefoon: +33 4 72 51 77 55",
        "HOSTED_BY_AWS": "Site aangebied deur: Amazon Web Services (AWS) in Parys, Frankryk",
        "HOSTING": "Akkommodasie",
        "HOSTING_AND_TECHNICAL_SOLUTION": "Webhosting en tegniese oplossing",
        "HOST_ADDRESS": "Gasheer se adres: 38 avenue John F. Kennedy, L-1855 Luxemburg",
        "PLATFORM_HOSTED_BY": "Die platform word gehuisves en aangedryf deur Fluicity Engage, 'n oplossing wat uitgegee word deur die maatskappy Fluicity.",
        "THIRD_PARTY_TRUST": "Fluicity Engage tree as 'n derdeparty-vertrouenspersoon vir die insameling en verwerking van data, in ooreenstemming met die AVG."
      },
      "LINKEDIN_URL_LABEL": "LinkedIn",
      "LINKEDIN_URL_PLACEHOLDER": "https://www.linkedin.com/mapage",
      "LOCALES": "Tale",
      "LOCALES_HELPER": "Kies die tale waarin gebruikers op jou platform kan blaai.",
      "LOCALES_LABEL": "Beskikbare tale",
      "LOCALE_DEFAULT_HELPER": "Kies die verstektaal van jou platform.",
      "LOCALE_DEFAULT_LABEL": "Standaardtaal",
      "LOGO_PICTURE_LABEL": "Beeld van administrateurs se profiel",
      "LOGO_PICTURE_TOOLTIP": "Wanneer hulle 'n konsultasie, 'n bydrae, 'n boodskap skep of kommentaar lewer op die platform, sal administrateurs deur hierdie profielfoto en die naam van die ruimte geïdentifiseer word in plaas van hul eie foto en naam.",
      "NAME_HELPER": "Die naam van die ruimte sal op baie plekke vertoon word: in die naam van bladsye, in e-posse, in plaas van die naam van administrateurs, ens.",
      "NAME_LABEL": "Naam van die ruimte",
      "NAME_PLACEHOLDER": "Stel die naam van jou ruimte in",
      "PHONE_LABEL": "Telefoon",
      "PHONE_PLACEHOLDER": "0123456789",
      "PRIMARY_COLOR_LABEL": "Hoofkleur",
      "PRIMARY_COLOR_PLACEHOLDER": "Hoofkleur",
      "SECONDARY_COLOR_LABEL": "Sekondêre kleur",
      "SECONDARY_COLOR_PLACEHOLDER": "Sekondêre kleur",
      "SPACE_DECISION_MAKER": "Borg",
      "SPACE_DECISION_MAKER_TOOLTIP": "Die borg is 'n persoonlikheid in u organisasie wat u gebruikers sal motiveer, gerusstel en betrek.",
      "SPACE_LEGAL_NOTICE": "Regterlike kennisgewings",
      "SPACE_LEGAL_NOTICE_LABEL": "Beskrywing",
      "SPACE_LEGAL_NOTICE_PLACEHOLDER": "Hierdie bladsy verskyn aan die onderkant van jou platform, onder die voetskrif, met vooraf ingevulde inligting deur Fluicity Engage as die gasheer en tegniese uitgewer van die oplossing.",
      "SPACE_LEGAL_NOTICE_TOOLTIP_1": "Regsbepalings laat gebruikers toe om ingelig te word oor die identiteit van die webwerf se verantwoordelike persoon, die gasheer, en die voorwaardes vir die publikasie van die platform.",
      "SPACE_LEGAL_NOTICE_TOOLTIP_2": "Hulle is verpligtend vir enige institusionele of openbare webwerf, en versterk die deursigtigheid van u benadering.",
      "SPACE_PRIVACY_POLICY": "Privaatheidsbeleid",
      "SPACE_PRIVACY_POLICY_LABEL": "Beskrywing",
      "SPACE_PRIVACY_POLICY_PLACEHOLDER": "Hierdie bladsy verskyn aan die onderkant van jou platform, onder die voetskrif, met Fluicity Engage-inligting.",
      "SPACE_PRIVACY_POLICY_TOOLTIP_1": "Die privaatheidsbeleid stel die deelnemers in kennis oor die verwerking van hul persoonlike data. U kan hier spesifieke besonderhede van u organisasie byvoeg (bv. spesifieke bewaringstydperk, kontak DPO, interne gebruik van data, ens.).",
      "SPACE_PRIVACY_POLICY_TOOLTIP_2": "Hierdie teks vul die <link>privaatheidsbeleid van Fluicity Engage</link> aan, die tegniese bestuurder van die platform, en waarborg van die GDPR-nakoming. Die byvoeging van jou eie teks bly opsioneel, afhangende van jou gebruik van die platform.",
      "SPACE_TERMS_OF_USE": "Gebruiksvoorwaardes",
      "SPACE_TERMS_OF_USE_LABEL": "Beskrywing",
      "SPACE_TERMS_OF_USE_PLACEHOLDER": "Voeg hier die inhoud van u gepersonaliseerde gebruiksvoorwaardes by",
      "SPACE_TERMS_OF_USE_TOOLTIP_1": "Die gebruiksvoorwaardes bepaal die reëls vir die regte gebruik van u ruimte, die regte en verantwoordelikhede van gebruikers, sowel as u verbintenisse as organiseerder van die proses. (bv. modereringsreëls, deelnemingsregte, ens.).",
      "SPACE_TERMS_OF_USE_TOOLTIP_2": "Hierdie teks vul die <link>CGU van Fluicity Engage</link> aan, as 'n vertroude derde party en uitgewer van die platform. Die byvoeging van jou eie teks bly opsioneel, afhangende van jou gebruik van die platform.",
      "TOPICS": "Temas",
      "TOPICS_DESCRIPTION": "Temas help om jou inhoud te kategoriseer sodat gebruikers die inhoud volgens hul belangstellings kan vind.",
      "TWITTER_URL_LABEL": "Twitter",
      "TWITTER_URL_PLACEHOLDER": "https://twitter.com/mynbladsy",
      "UPDATED_SUCCESSFULLY": "Jou ruimte is suksesvol opgedateer.",
      "USERS_NOTIFICATIONS_SETTINGS": {
        "EVENTABLE": {
          "LABEL": "Stuur outomaties 'n kennisgewing wanneer 'n konsultasie begin en vir al sy deelnemingsfases."
        },
        "TITLE": "Kennisgewings",
        "WEEKLY": {
          "LABEL": "Stuur 'n opsomming van die week se nuus aan die intekenare (nuwe artikels, nuwe geleenthede en herinnerings om aan 'n konsultasie deel te neem)."
        }
      },
      "WEBSITE_URL_LABEL": "Webwerf",
      "WEBSITE_URL_PLACEHOLDER": "https://www.monsite.com",
      "YOUR_SPACE": "Jou ruimte"
    },
    "HOME": {
      "AFFILIATES": {
        "AFFILIATED": "Gekoppelde ruimtes",
        "SEE_MORE": "Sien meer ({count})"
      },
      "FOOTER": {
        "TITLE": "Kom ons bly in kontak!"
      },
      "SEE": "Sien",
      "SPACE_INFO": {
        "CITIZENS_COUNT": "{count, plural, =0 {Geen inskrywings} one {{count} inskrywing} other {{count} inskrywings}}",
        "IDEAS_COUNT": "{count, plural, =0 {Geen deelname} one {{count} deelname} other {{count} deelnames}}"
      },
      "SPONSOR": "Hierdie ruimte is geassosieer met"
    },
    "NEWS": {
      "EMPTY_STATE": "Hier sal u die artikels en gebeurtenisse vind wat deur die organisasie gepubliseer is.",
      "TITLE": "{count, plural, =0 {Geen nuus} one {{count} nuusartikel} other {{count} nuusartikels}}"
    },
    "PRIVACY_POLICY": {
      "ACCESS_FLUICITY_PRIVACY": "Raadpleeg Fluicity Engage se privaatheidsbeleid"
    },
    "SETTINGS": {
      "ACCESS": {
        "TAB_DATA_COLLECTION": "Registrasievorm",
        "TAB_INVITATIONS": "Uitnodigings"
      },
      "COMMUNICATION": {
        "TAB_NOTIFICATIONS": "Kennisgewings"
      },
      "GENERAL": {
        "TAB_APPEARANCE": "Voorkoms",
        "TAB_LANGUAGES": "Tale",
        "TAB_TOPICS": "Temas"
      },
      "LEGAL": {
        "TAB_LEGAL_NOTICE": "Regswysigings",
        "TAB_PRIVACY_POLICY": "Privaatheidsbeleid",
        "TAB_TERMS_OF_USE": "Gebruiksvoorwaardes"
      },
      "PAGES": {
        "TAB_ABOUT": "Oor ons",
        "TAB_FOOTER": "Voetskrif",
        "TAB_HOME": "Tuisblad",
        "TAB_NAVIGATION": "Navigasie balk"
      }
    },
    "TERMS_OF_USE": {
      "ACCESS_FLUICITY_TERMS": "Raadpleeg die gebruiksvoorwaardes van Fluicity Engage"
    }
  },
  "SPACE_DATA_COLLECTION": {
    "GENERAL_INFO": "Algemene inligting",
    "PROF_CATEGORY_ID": {
      "LABEL": "Sosio-professionele Kategorie"
    },
    "SECTION": {
      "HEADER": "Registrasievorm",
      "SUBTITLE1": "Die inskrywingsvorm is 'n instrument wat help om data oor gebruikers in te samel.",
      "SUBTITLE2": "Stel die versamelvelde op volgens jou behoeftes terwyl jy die AVG respekteer."
    }
  },
  "STATS": {
    "AGE": {
      "BETWEEN_15_AND_29": "15–29",
      "BETWEEN_30_AND_44": "30-44",
      "BETWEEN_45_AND_59": "45-59",
      "BETWEEN_60_AND_74": "60-74",
      "GT_75": ">75",
      "LT_15": "<15",
      "TITLE": "Ouderdom"
    },
    "AI": {
      "ACTIONS": "Gebruikers se aspirasies:",
      "ACTIONS_TOOLTIP": "Hierdie opsomming van die gebruikers se aspirasies is deur AI gegenereer. Dit het ten doel om u te help om die oorspronklike bydraes van die deelnemers te interpreteer. Dit is gebaseer op die bydraes wat hieronder saamgevoeg is.",
      "ADD_CLUSTER": "Voeg 'n temagroep by",
      "ADD_SUB_CLUSTER": "Voeg 'n subgroep by",
      "CLUSTER": {
        "SUMMARY": "Beskrywing van die temagroep",
        "SUMMARY_PLACEHOLDER": "Die beskrywing van die tematiese groep",
        "TITLE": "Naam van die tematiese groep",
        "TITLE_PLACEHOLDER": "Die naam van die tematiese groep sal deur die KI gebruik word om die bydraes te groepeer."
      },
      "DELETE": "Verwyder",
      "DESCRIPTION": "Beskrywing:",
      "EDIT": "Wysiger",
      "EDIT_CLUSTER": "Wysig die tema",
      "EDIT_SUB_CLUSTER": "Wysig die subgroep",
      "EXPLAIN_AI": "Ons gebruik kunsmatige intelligensie om die bydraes van hierdie konsultasie noukeurig te ondersoek. Ons doel is om dit in verskillende kategorieë te groepeer op grond van hul ooreenkoms, sodat ons u 'n beter begrip van die neigings, die hoofaspirasies en die opkomende bydraes kan bied. Danksy hierdie benadering sal u die bydraes wat na vore kom en die menings wat in hierdie konsultasie na vore kom, beter kan verstaan.",
      "GENERATE": "Begin die ontleding",
      "IDEAS": "Oorspronklike bydraes:",
      "IN_FAVOR": "Giet",
      "MOVE_IDEA": "Skuif",
      "MOVE_IDEA_TITLE": "Verander temagroep of subgroep",
      "OPPOSED": "Teen",
      "SUB_CLUSTER": {
        "SUMMARY": "Beskrywing van subgroep",
        "SUMMARY_PLACEHOLDER": "Die beskrywing van die subgroep",
        "TITLE": "Naam van die subgroep",
        "TITLE_PLACEHOLDER": "Die naam van die tematiese subgroep sal deur die KI gebruik word om die bydraes te groepeer."
      },
      "TOAST": "Die AI-analise is aan die gang. Dit kan 'n paar minute neem."
    },
    "CITIES": {
      "TITLE": "Woonplek"
    },
    "CLUSTERS": "Tematiese groepe",
    "CLUSTERS_TOOLTIP": "Die verskillende aspirasies van gebruikers word deur die KI binne een of meer temas gegroepeer.",
    "CLUSTER_OTHER": "Ander",
    "COUNTER_WITH_TREND": {
      "TOOLTIP": "Oor die afgelope 7 dae"
    },
    "COUNT_PROPOSALS": "{count} {count, plural, 0 {bydrae} one {bydrae} other {bydraes}}",
    "DAY": "Dag",
    "DELIVERABILITY": "Dostuurbaarheid",
    "IDEAS_STATUSES": {
      "TITLE": "Status van bydraes"
    },
    "KPIS": {
      "TOTAL_COMMENTS": "{count, plural, 0 {Kommentaar} one {Kommentaar} other {Kommentaar}}",
      "TOTAL_FORM_RESPONSES": "{count, plural, 0 {Antwoord} one {Antwoord} other {Antwoorde}}",
      "TOTAL_PARTICIPANTS": "{count, plural, 0 {Deelnemer} one {Deelnemer} other {Deelnemers}}",
      "TOTAL_VOTES_AGAINST": "{count, plural, 0 {Teenstem} one {Teenstem} other {Teenstemme}}",
      "TOTAL_VOTES_FOR": "{count, plural, 0 {Stem vir} one {Stem vir} other {Stemme vir}}"
    },
    "MONTH": "Maand",
    "NO_DATA": "Daar is nog nie data beskikbaar op die oomblik nie.",
    "PARTICIPANTS": {
      "TITLE": "Aantal deelnemers",
      "TOTAL_PARTICIPANTS": "Deelnemers",
      "TOTAL_TARGETED_USERS": "Geregistreerde gebruikers"
    },
    "PARTICIPANTS_PROGRESSION": "Deelnemersontwikkeling",
    "PARTICIPANTS_WHO_PERFORMED_AN_ACTION": {
      "TITLE": "Aksies uitgevoer deur die deelnemers",
      "TOTAL_COMMENTS": "Kommentaar",
      "TOTAL_IDEAS": "Maak 'n bydrae",
      "TOTAL_NO_ACTIONS": "Geen aksie",
      "TOTAL_STUDY_ANSWERS": "Opname-antwoorde",
      "TOTAL_VOTES": "Stem"
    },
    "PARTICIPATION_PROGRESSION": "Ontwikkeling van deelname",
    "PERFORMANCE": "Prestasie",
    "PROF_CATEGORIES": {
      "TITLE": "Sosio-professionele kategorië"
    },
    "REFERRERS": "Verkeerbronne",
    "SECTIONS": {
      "ACTIVITY": "Aktiwiteit",
      "ENGAGEMENT": "Betrokkenheid",
      "PARTICIPANTS_PROFILE": "Deelnemersprofiel"
    },
    "SEX": {
      "TITLE": "Geslag",
      "TOTAL_": "Nie gespesifiseer nie",
      "TOTAL_FEMALE": "Vrou",
      "TOTAL_MALE": "Man",
      "TOTAL_UNSPECIFIED": "Nie gespesifiseer nie"
    },
    "SUBSCRIPTIONS": {
      "TITLE": "Inskrywingsdoelwitte",
      "TOTAL_TARGETED_USERS": "Doelwit",
      "TOTAL_USERS": "Geregistreerde gebruikers"
    },
    "SUBSCRIPTION_PROGRESSION": {
      "TITLE": "Ontwikkeling van registrasies"
    },
    "TAB_AI": "Kunsmatige Intelligensie Analise (bèta)",
    "TAB_ATTENDEES": "Deelnemers",
    "TAB_CONTENTS": "Inhoud",
    "TAB_DETAILS": "Besonderhede",
    "TAB_EMAILS": "E-pos met die outeur",
    "TAB_LIST": "Lys",
    "TAB_PARTICIPATION": "Deelname",
    "TAB_PRIVATE_NOTES": "Interne aantekeninge",
    "TAB_PROPOSALS": "Bydraes",
    "TAB_RESPONSES": "Antwoorde",
    "TAB_RESULTS": "Resultate",
    "TAB_SETTINGS": "Instellings",
    "TAB_STATS": "Statistieke",
    "TAB_VOTES": "Stemme",
    "TARGETED_POPULATION": "Demografie (amptelike bron)",
    "TOP_CONSULTATIONS": {
      "COL_TITLE": "Titel",
      "COL_TOTAL": "Deelnemers",
      "SUBTITLE": "Totale bydraes, kommentare, stemme of antwoorde op die opname",
      "TITLE": "Gewilde raadplegings"
    },
    "TOP_VIEWED_POSTS": {
      "COL_TITLE": "Titel",
      "COL_TOTAL": "Besoekers",
      "COL_TYPE": "Tik",
      "TITLE": "Mees besoekte inhoud"
    },
    "TOTAL_ANSWERS": "{answersCount} van {totalCount} {totalCount, plural, one {respondent} other {respondente}}",
    "TOTAL_BOUNCED": "Weerkaats",
    "TOTAL_CLICKED": "Klik",
    "TOTAL_COMMENTS": "Kommentaar",
    "TOTAL_COMMUNICATIONS": "Nuus",
    "TOTAL_CONSULTATIONS": "Konsultasies",
    "TOTAL_DELIVERED": "Uitgereik",
    "TOTAL_IDEAS": "Bydraes",
    "TOTAL_OFFLINE_VOTES": "Aflyn stemme",
    "TOTAL_ONLINE_VOTES": "Aanlyn stemme",
    "TOTAL_OPENED": "Oop",
    "TOTAL_PARTICIPANTS": "Deelnemers",
    "TOTAL_REJECTED": "Verwerp",
    "TOTAL_RESPONDENTS": "Respondente",
    "TOTAL_SENT": "Gestuur",
    "TOTAL_STUDY_ANSWERS": "Opname antwoorde",
    "TOTAL_USERS": "Geregistreerde gebruikers",
    "TOTAL_VOTERS": "Stemmers",
    "TOTAL_VOTES": "Stemme",
    "UNIQUE_VISITS": "Unieke besoeke",
    "USERS_WHO_ANSWERED": "{count} {count, plural, =0 {respondent} one {respondent} other {respondente}}",
    "USERS_WHO_PERFORMED_AN_ACTION": {
      "TITLE": "Aksies uitgevoer deur gebruikers",
      "TOTAL_COMMENTS": "Kommentaar",
      "TOTAL_IDEAS": "Maak 'n bydrae",
      "TOTAL_NO_ACTIONS": "Geen aksie",
      "TOTAL_STUDY_ANSWERS": "Opname-antwoorde",
      "TOTAL_VOTES": "Stem"
    },
    "WEEK": "Week",
    "WORD_CLOUD": "Woorde wolk"
  },
  "TEXT_FIELD": {
    "LENGTH": "{length}/{maxLength}",
    "LENGTH_ERROR": "{length}/{maxLength} - U het die limiet van karakters oorskry.",
    "LENGTH_ERROR_TEXT": "U het die karakterlimiet oorskry."
  },
  "TOGGLE_POSTS_VIEW": {
    "BUTTON_CAROUSEL": "Karrousel",
    "BUTTON_GROUP": "Verander vertoonmodus",
    "BUTTON_LIST": "Lys",
    "BUTTON_MAP": "Kaart"
  },
  "TOKENS": "{count, plural, =0 {Geen token} one {{count} token} other {{count} tokens}}",
  "TOPIC_FORM": {
    "ADD_TOPIC": "Voeg 'n tema by",
    "DESTROY_WARNING_DIALOG": {
      "DESCRIPTION_1": "Een of meer inhoud op jou platform is tans onder hierdie tema gekategoriseer.",
      "DESCRIPTION_2": "Deur dit te wysig of te verwyder, sal jy die klassifikasie van hierdie inhoud verander.",
      "TITLE": "Is jy seker?"
    }
  },
  "TRANSLATION": {
    "REVERSE_TRANSLATE": "Sien die oorspronklike teks",
    "SUCCESS": "Die vertaling is suksesvol uitgevoer.",
    "TRANSLATE": "Vertaal",
    "TRANSLATING": "Vertaling aan die gang…"
  },
  "UI_SECTION": {
    "FORM": {
      "ABOUT": {
        "SECTION_DESCRIPTION": "Blokke laat jou toe om jou bladsy aan te pas deur teks, beeld en video inligting uit te lig.",
        "SECTION_HEADER": "Blokke"
      },
      "HOME": {
        "SECTION_DESCRIPTION": "Blokke laat jou toe om jou bladsy aan te pas deur teks, beeld, video en uitgeligte inhoud na vore te bring.",
        "SECTION_HEADER": "Blokke"
      },
      "ITEMS": {
        "ANOMALY_FORM": {
          "DESCRIPTION": "Aanmelding van 'n probleem in privaat",
          "TITLE": "Afwyking"
        },
        "CUSTOM_BLOCK": {
          "DESCRIPTION": "Teks, beeld en video",
          "TITLE": "Aangepas"
        },
        "DEMAND_FORM": {
          "DESCRIPTION": "Privaat kontak via die platform",
          "TITLE": "Boodskapdiens"
        },
        "FEATURED_CONSULTATIONS": {
          "DESCRIPTION": "Gewilde konsultasie, tans aan die gang en komende",
          "TITLE": "Raadpleging"
        },
        "FEATURED_NEWS": {
          "DESCRIPTION": "Artikel en gebeurtenis",
          "TITLE": "Nuus"
        },
        "FOLDERS": {
          "DESCRIPTION": "Lêergids en sublêergids",
          "TITLE": "Leêr"
        },
        "KPIS": {
          "DESCRIPTION": "Aantal geregistreerdes, bydraes en konsultasies",
          "TITLE": "'n Paar syfers"
        },
        "LATEST_IDEAS": {
          "DESCRIPTION": "Gebruikersdeelname",
          "TITLE": "Bydrae"
        },
        "SPACE_INFO": {
          "TITLE": "Bo-strook"
        }
      },
      "LAYER_ADD_MEDIA": "Voeg 'n media by",
      "LAYER_ADD_PICTURE": "Beeld",
      "LAYER_ADD_VIDEO": "Video",
      "LAYER_ALIGNMENT": {
        "CENTER": {
          "DESCRIPTION": "Die tekste is gesentreer teenoor die media.",
          "LABEL": "Gesentrummeer"
        },
        "LEFT": {
          "DESCRIPTION": "Die tekste is links van die media.",
          "LABEL": "Links"
        },
        "RIGHT": {
          "DESCRIPTION": "Die tekste is aan die regterkant van die media.",
          "LABEL": "Regs."
        },
        "TITLE": "Vertoning"
      },
      "LAYER_COMMUNICATION_TYPE": {
        "ALL": "Alle nuus",
        "ARTICLE": "Artikel",
        "EVENT": "Gebeurtenis",
        "LABEL": "Tik",
        "PINNED": "Nuusflits"
      },
      "LAYER_CONSULTATION_TYPE": {
        "ALL": "Alle konsultasies",
        "ENDED": "Konsultasies afgehandel",
        "LABEL": "Tik soorte",
        "ONGOING": "Lopende konsultasies",
        "PINNED": "Op die voorgrond"
      },
      "LAYER_COUNTERS": {
        "CONSULTATIONS_COUNT": "Begin konsultasies",
        "CONTRIBUTIONS_COUNT": "Gerealiseerde bydraes",
        "PARTICIPATIONS_COUNT": "Deelnames (bydraes, opname-antwoorde, stemme en kommentare)",
        "TITLE": "Wys die aantal van:",
        "USERS_AND_PARTICIPATIONS_COUNT": "Geregistreerdes en deelnames",
        "USERS_COUNT": "Ingeskryfdes"
      },
      "LAYER_CTA_LABEL": "Knoppie-etiket",
      "LAYER_CTA_LABEL_PLACEHOLDER": "Wat u op die knoppie wil vertoon",
      "LAYER_CTA_URL": "Knoppie-URL",
      "LAYER_CTA_URL_PLACEHOLDER": "Skakel na 'n bladsy of 'n dokument",
      "LAYER_DESCRIPTION_LABEL": "Beskrywing",
      "LAYER_DESCRIPTION_PLACEHOLDER": "Voeg hier die teksinhoud van die blok by. Wees bondig en trefseker.",
      "LAYER_FILTERING_TYPE": {
        "ALL": "Alle lêers",
        "CHILDREN": "Inhoud van 'n lêergids",
        "CUSTOM": "Aangepas",
        "SELECT_FOLDER": "Kies 'n vouer",
        "SELECT_FOLDERS": "Kies die vouers",
        "TYPE_LABEL": "Filtreringstipe"
      },
      "LAYER_PICTURE_LABEL": "Beeld",
      "LAYER_TITLE_LABEL": "Titel",
      "LAYER_TITLE_PLACEHOLDER": "Stel 'n titel vir die blok in",
      "SELECTION_DIALOG": {
        "TITLE": "Skep 'n blok"
      }
    }
  },
  "USERS": {
    "ACTIONS_MENU": {
      "CONTACT_USER": "Kontak die gebruiker",
      "INVITE": "Nooi",
      "UNREGISTER": "Uitskryf",
      "UPDATE_ROLE": "Stel die rol op"
    },
    "EXPORT": "Uitvoer van gebruikersdata",
    "EXPORT_SUCCESS_TOAST": "Die uitvoer is aan die gang. U sal 'n e-pos ontvang sodra dit gereed is.",
    "INVITATIONS": {
      "CREATE_FORM": {
        "EMAILS_LABEL": "Lys van e-posse geskei deur kommas",
        "EMAILS_PLACEHOLDER": "Voorbeeld: gebruiker1@organisasie.com, gebruiker2@vereniging.org",
        "MESSAGE_LABEL": "Uitnodigingsboodskap",
        "MESSAGE_PLACEHOLDER": "Voer 'n kort en inspirerende uitnodigingsboodskap in wat gaste sal aanmoedig om by jou ruimte aan te sluit en deel te neem.",
        "SUCCESS_TOAST": "Die gebruikers is suksesvol uitgenooi.",
        "TITLE": "Nooi gebruikers",
        "WARNING": "Maak seker dat u die toestemming van die gebruikers verkry het voordat u hul e-pos gebruik om hulle uit te nooi."
      },
      "DELETE_FORM": {
        "CONTENT": "U is op die punt om die uitnodiging wat aan <b>{email}</b> gestuur is, te kanselleer. Is u seker dat u wil voortgaan?",
        "DELETE": "Verwyder",
        "TITLE": "Verwyder die uitnodiging"
      }
    },
    "UNREGISTER": {
      "DESCRIPTION_1": "U is op die punt om die gebruiker “<strong>{userName}</strong>” van u deelname-ruimte uit te skryf.",
      "DESCRIPTION_2": "As die ruimte privaat is, sal die betrokke gebruiker nie meer toegang tot die ruimte hê nie. U moet hom/haar hernooi om hierdie aksie te kanselleer.",
      "DESCRIPTION_3": "As die ruimte openbaar is, sal die betrokke gebruiker nie meer kan deelneem nie. Hy sal weer moet registreer om hierdie aksie te kanselleer.",
      "DESCRIPTION_4": "Is u seker dat u met die operasie wil voortgaan?",
      "TITLE": "Verwyder gebruikerregistrasie"
    }
  },
  "USER_AVATAR": "Gebruiker se avatar",
  "USER_VOTES_INFO": {
    "MAX_VOTES_ERROR": "Jy het die maksimum aantal stemme bereik.",
    "MAX_VOTES_WARNING": "{count, plural, =0 {Jy kan nie meer bydraes ondersteun nie} one {Jy kan <strong># bydrae</strong> ekstra ondersteun.} other {Jy kan <strong># bydraes</strong> ekstra ondersteun.}}",
    "MIN_VOTES_WARNING": "{count, plural, =0 {U ondersteun genoeg bydraes} one {Nog <strong># ondersteuning</strong> om u deelname te valideer.} other {Nog <strong># ondersteunings</strong> om u deelname te valideer.}}",
    "VALID_PARTICIPATION": "Jou deelname is bekragtig."
  },
  "VIEW_ALL": "Sien alles",
  "VIRUS_SCAN": {
    "CLEAN": "Antivirus-analise reg in orde",
    "INFECTED": "Beskadigde lêer",
    "INFECTED_ATTACHMENTS_ERROR": "'n Dokument lyk besmet. Verwyder dit asseblief voordat jy dit stoor.",
    "NO_SCAN": "Antivirus-analise aan die gang"
  },
  "VOTERS": {
    "DUPLICATES": {
      "CARD": {
        "BIRTHDATE": "Geboortedatum: {birthdate}",
        "DELETE_VOTE": "Verwyder die stem",
        "EMPTY": "Nie verstrek nie",
        "IMPORTED_AT": "Ingevoer op {date}",
        "KEEP_BOTH": "Hou albei",
        "PARTICIPATED_AT": "Deelname op {date}"
      },
      "DESCRIPTION": "Die analise van duplikate neem die naam en van van die gebruikers in ag. Om die duplikaat te hanteer, kies die stem wat jy wil verwyder uit die twee deelnames.",
      "FOUND_DUPLICATES": "Jy het <b>{count, plural, one {{count} dubbele geregistreerde kieser} other {{count} dubbele geregistreerde kiesers}}</b>. Laaste opdatering <b>{timeAgo}</b>",
      "LOADING": "Verifikasie aan die gang…",
      "NO_DUPLICATES": "Geen duplikaat geïdentifiseer nie. Laaste opdatering <b>{timeAgo}</b>",
      "PLACEHOLDER": "Hier sal u die kiesers vind wat as duplikate geïdentifiseer is.",
      "REFRESH": "Verfris",
      "START_CHECK": "Begin die verifikasie",
      "TITLE": "Bestuur duplikate"
    }
  },
  "WYSIWYG": {
    "LINK_PROMPT": {
      "ENTER_URL": "Voer die URL in"
    },
    "PLACEHOLDER": "Begin om te tik..."
  }
}